var map = {
	"./0-circle-fill.svg": [
		73815,
		73815
	],
	"./0-circle.svg": [
		50587,
		50587
	],
	"./0-square-fill.svg": [
		25492,
		25492
	],
	"./0-square.svg": [
		43098,
		43098
	],
	"./1-circle-fill.svg": [
		57918,
		57918
	],
	"./1-circle.svg": [
		40172,
		40172
	],
	"./1-square-fill.svg": [
		26129,
		26129
	],
	"./1-square.svg": [
		84725,
		84725
	],
	"./123.svg": [
		16926,
		16926
	],
	"./2-circle-fill.svg": [
		72093,
		72093
	],
	"./2-circle.svg": [
		36329,
		36329
	],
	"./2-square-fill.svg": [
		68734,
		68734
	],
	"./2-square.svg": [
		34668,
		34668
	],
	"./3-circle-fill.svg": [
		21700,
		21700
	],
	"./3-circle.svg": [
		91754,
		91754
	],
	"./3-square-fill.svg": [
		67379,
		67379
	],
	"./3-square.svg": [
		65615,
		65615
	],
	"./4-circle-fill.svg": [
		1219,
		1219
	],
	"./4-circle.svg": [
		12703,
		12703
	],
	"./4-square-fill.svg": [
		15104,
		15104
	],
	"./4-square.svg": [
		72110,
		72110
	],
	"./5-circle-fill.svg": [
		63594,
		63594
	],
	"./5-circle.svg": [
		23648,
		23648
	],
	"./5-square-fill.svg": [
		37181,
		37181
	],
	"./5-square.svg": [
		46665,
		46665
	],
	"./6-circle-fill.svg": [
		67625,
		67625
	],
	"./6-circle.svg": [
		4925,
		4925
	],
	"./6-square-fill.svg": [
		37613,
		37613
	],
	"./6-square.svg": [
		82256,
		82256
	],
	"./7-circle-fill.svg": [
		88592,
		88592
	],
	"./7-circle.svg": [
		55537,
		77918
	],
	"./7-square-fill.svg": [
		34495,
		34495
	],
	"./7-square.svg": [
		71347,
		71347
	],
	"./8-circle-fill.svg": [
		78751,
		78751
	],
	"./8-circle.svg": [
		82003,
		82003
	],
	"./8-square-fill.svg": [
		82492,
		82492
	],
	"./8-square.svg": [
		35506,
		35506
	],
	"./9-circle-fill.svg": [
		44070,
		44070
	],
	"./9-circle.svg": [
		1860,
		1860
	],
	"./9-square-fill.svg": [
		23001,
		23001
	],
	"./9-square.svg": [
		96589,
		96589
	],
	"./activity.svg": [
		51993,
		51993
	],
	"./airplane-engines-fill.svg": [
		51936,
		51936
	],
	"./airplane-engines.svg": [
		11310,
		11310
	],
	"./airplane-fill.svg": [
		19206,
		19206
	],
	"./airplane.svg": [
		81796,
		81796
	],
	"./alarm-fill.svg": [
		17117,
		17117
	],
	"./alarm.svg": [
		87465,
		87465
	],
	"./alexa.svg": [
		97327,
		97327
	],
	"./align-bottom.svg": [
		29663,
		29663
	],
	"./align-center.svg": [
		87537,
		87537
	],
	"./align-end.svg": [
		10329,
		10329
	],
	"./align-middle.svg": [
		96857,
		96857
	],
	"./align-start.svg": [
		26154,
		26154
	],
	"./align-top.svg": [
		54051,
		54051
	],
	"./alipay.svg": [
		67328,
		67328
	],
	"./alphabet-uppercase.svg": [
		58888,
		58888
	],
	"./alphabet.svg": [
		92239,
		92239
	],
	"./alt.svg": [
		34247,
		34247
	],
	"./amazon.svg": [
		26922,
		26922
	],
	"./amd.svg": [
		40532,
		40532
	],
	"./android.svg": [
		26911,
		26911
	],
	"./android2.svg": [
		78863,
		78863
	],
	"./anthropic.svg": [
		36586,
		36586
	],
	"./app-indicator.svg": [
		21211,
		21211
	],
	"./app.svg": [
		61479,
		61479
	],
	"./apple-music.svg": [
		24060,
		24060
	],
	"./apple.svg": [
		61534,
		61534
	],
	"./archive-fill.svg": [
		19574,
		19574
	],
	"./archive.svg": [
		8404,
		8404
	],
	"./arrow-90deg-down.svg": [
		29140,
		29140
	],
	"./arrow-90deg-left.svg": [
		82163,
		82163
	],
	"./arrow-90deg-right.svg": [
		12918,
		12918
	],
	"./arrow-90deg-up.svg": [
		72527,
		72527
	],
	"./arrow-bar-down.svg": [
		93118,
		93118
	],
	"./arrow-bar-left.svg": [
		98037,
		98037
	],
	"./arrow-bar-right.svg": [
		50040,
		50040
	],
	"./arrow-bar-up.svg": [
		9365,
		9365
	],
	"./arrow-clockwise.svg": [
		95676,
		95676
	],
	"./arrow-counterclockwise.svg": [
		65212,
		65212
	],
	"./arrow-down-circle-fill.svg": [
		10287,
		10287
	],
	"./arrow-down-circle.svg": [
		60003,
		60003
	],
	"./arrow-down-left-circle-fill.svg": [
		74409,
		74409
	],
	"./arrow-down-left-circle.svg": [
		66781,
		66781
	],
	"./arrow-down-left-square-fill.svg": [
		51066,
		51066
	],
	"./arrow-down-left-square.svg": [
		23920,
		23920
	],
	"./arrow-down-left.svg": [
		38032,
		38032
	],
	"./arrow-down-right-circle-fill.svg": [
		2542,
		2542
	],
	"./arrow-down-right-circle.svg": [
		59516,
		59516
	],
	"./arrow-down-right-square-fill.svg": [
		76961,
		76961
	],
	"./arrow-down-right-square.svg": [
		22917,
		22917
	],
	"./arrow-down-right.svg": [
		69439,
		69439
	],
	"./arrow-down-short.svg": [
		44431,
		44431
	],
	"./arrow-down-square-fill.svg": [
		70956,
		70956
	],
	"./arrow-down-square.svg": [
		97154,
		97154
	],
	"./arrow-down-up.svg": [
		70976,
		70976
	],
	"./arrow-down.svg": [
		40934,
		40934
	],
	"./arrow-left-circle-fill.svg": [
		43156,
		43156
	],
	"./arrow-left-circle.svg": [
		85338,
		85338
	],
	"./arrow-left-right.svg": [
		83132,
		83132
	],
	"./arrow-left-short.svg": [
		44608,
		44608
	],
	"./arrow-left-square-fill.svg": [
		5731,
		5731
	],
	"./arrow-left-square.svg": [
		61407,
		61407
	],
	"./arrow-left.svg": [
		75053,
		75053
	],
	"./arrow-repeat.svg": [
		71367,
		71367
	],
	"./arrow-return-left.svg": [
		45430,
		45430
	],
	"./arrow-return-right.svg": [
		20661,
		20661
	],
	"./arrow-right-circle-fill.svg": [
		10345,
		10345
	],
	"./arrow-right-circle.svg": [
		69885,
		69885
	],
	"./arrow-right-short.svg": [
		93693,
		93693
	],
	"./arrow-right-square-fill.svg": [
		91354,
		91354
	],
	"./arrow-right-square.svg": [
		32720,
		32720
	],
	"./arrow-right.svg": [
		7664,
		7664
	],
	"./arrow-through-heart-fill.svg": [
		74876,
		74876
	],
	"./arrow-through-heart.svg": [
		62610,
		62610
	],
	"./arrow-up-circle-fill.svg": [
		17764,
		17764
	],
	"./arrow-up-circle.svg": [
		98122,
		98122
	],
	"./arrow-up-left-circle-fill.svg": [
		57840,
		57840
	],
	"./arrow-up-left-circle.svg": [
		21086,
		21086
	],
	"./arrow-up-left-square-fill.svg": [
		75263,
		75263
	],
	"./arrow-up-left-square.svg": [
		56659,
		56659
	],
	"./arrow-up-left.svg": [
		59041,
		59041
	],
	"./arrow-up-right-circle-fill.svg": [
		56013,
		56013
	],
	"./arrow-up-right-circle.svg": [
		14425,
		14425
	],
	"./arrow-up-right-square-fill.svg": [
		26305,
		26305
	],
	"./arrow-up-right-square.svg": [
		30428,
		30428
	],
	"./arrow-up-right.svg": [
		66508,
		66508
	],
	"./arrow-up-short.svg": [
		19152,
		19152
	],
	"./arrow-up-square-fill.svg": [
		94771,
		94771
	],
	"./arrow-up-square.svg": [
		52495,
		52495
	],
	"./arrow-up.svg": [
		70141,
		70141
	],
	"./arrows-angle-contract.svg": [
		70797,
		70797
	],
	"./arrows-angle-expand.svg": [
		25247,
		25247
	],
	"./arrows-collapse-vertical.svg": [
		80215,
		80215
	],
	"./arrows-collapse.svg": [
		17204,
		17204
	],
	"./arrows-expand-vertical.svg": [
		9116,
		9116
	],
	"./arrows-expand.svg": [
		53933,
		53933
	],
	"./arrows-fullscreen.svg": [
		62786,
		62786
	],
	"./arrows-move.svg": [
		85490,
		85490
	],
	"./arrows-vertical.svg": [
		56571,
		56571
	],
	"./arrows.svg": [
		20648,
		20648
	],
	"./aspect-ratio-fill.svg": [
		91978,
		91978
	],
	"./aspect-ratio.svg": [
		5696,
		5696
	],
	"./asterisk.svg": [
		92966,
		92966
	],
	"./at.svg": [
		70849,
		70849
	],
	"./award-fill.svg": [
		44373,
		44373
	],
	"./award.svg": [
		14641,
		14641
	],
	"./back.svg": [
		943,
		943
	],
	"./backpack-fill.svg": [
		81562,
		81562
	],
	"./backpack.svg": [
		55024,
		55024
	],
	"./backpack2-fill.svg": [
		396,
		396
	],
	"./backpack2.svg": [
		20066,
		20066
	],
	"./backpack3-fill.svg": [
		83999,
		83999
	],
	"./backpack3.svg": [
		50643,
		50643
	],
	"./backpack4-fill.svg": [
		92382,
		92382
	],
	"./backpack4.svg": [
		93900,
		93900
	],
	"./backspace-fill.svg": [
		94259,
		94259
	],
	"./backspace-reverse-fill.svg": [
		54532,
		54532
	],
	"./backspace-reverse.svg": [
		89354,
		89354
	],
	"./backspace.svg": [
		10575,
		10575
	],
	"./badge-3d-fill.svg": [
		44433,
		44433
	],
	"./badge-3d.svg": [
		40437,
		40437
	],
	"./badge-4k-fill.svg": [
		73731,
		73731
	],
	"./badge-4k.svg": [
		97068,
		74687
	],
	"./badge-8k-fill.svg": [
		39695,
		39695
	],
	"./badge-8k.svg": [
		18339,
		18339
	],
	"./badge-ad-fill.svg": [
		58819,
		58819
	],
	"./badge-ad.svg": [
		72159,
		72159
	],
	"./badge-ar-fill.svg": [
		50981,
		50981
	],
	"./badge-ar.svg": [
		16545,
		16545
	],
	"./badge-cc-fill.svg": [
		48020,
		48020
	],
	"./badge-cc.svg": [
		20890,
		20890
	],
	"./badge-hd-fill.svg": [
		15974,
		15974
	],
	"./badge-hd.svg": [
		5668,
		5668
	],
	"./badge-sd-fill.svg": [
		72593,
		72593
	],
	"./badge-sd.svg": [
		4821,
		4821
	],
	"./badge-tm-fill.svg": [
		16757,
		16757
	],
	"./badge-tm.svg": [
		9137,
		9137
	],
	"./badge-vo-fill.svg": [
		17841,
		17841
	],
	"./badge-vo.svg": [
		1045,
		1045
	],
	"./badge-vr-fill.svg": [
		45194,
		45194
	],
	"./badge-vr.svg": [
		27744,
		27744
	],
	"./badge-wc-fill.svg": [
		2592,
		2592
	],
	"./badge-wc.svg": [
		30542,
		30542
	],
	"./bag-check-fill.svg": [
		92303,
		92303
	],
	"./bag-check.svg": [
		71331,
		71331
	],
	"./bag-dash-fill.svg": [
		15101,
		15101
	],
	"./bag-dash.svg": [
		8297,
		8297
	],
	"./bag-fill.svg": [
		77722,
		77722
	],
	"./bag-heart-fill.svg": [
		39243,
		39243
	],
	"./bag-heart.svg": [
		85591,
		85591
	],
	"./bag-plus-fill.svg": [
		85229,
		85229
	],
	"./bag-plus.svg": [
		25401,
		25401
	],
	"./bag-x-fill.svg": [
		4091,
		4091
	],
	"./bag-x.svg": [
		67431,
		67431
	],
	"./bag.svg": [
		91600,
		91600
	],
	"./balloon-fill.svg": [
		20711,
		20711
	],
	"./balloon-heart-fill.svg": [
		71794,
		71794
	],
	"./balloon-heart.svg": [
		19800,
		19800
	],
	"./balloon.svg": [
		44811,
		44811
	],
	"./ban-fill.svg": [
		47981,
		47981
	],
	"./ban.svg": [
		82137,
		82137
	],
	"./bandaid-fill.svg": [
		14223,
		14223
	],
	"./bandaid.svg": [
		50467,
		50467
	],
	"./bank.svg": [
		31696,
		31696
	],
	"./bank2.svg": [
		65250,
		65250
	],
	"./bar-chart-fill.svg": [
		71944,
		71944
	],
	"./bar-chart-line-fill.svg": [
		23665,
		23665
	],
	"./bar-chart-line.svg": [
		15093,
		15093
	],
	"./bar-chart-steps.svg": [
		19924,
		19924
	],
	"./bar-chart.svg": [
		57638,
		57638
	],
	"./basket-fill.svg": [
		57358,
		57358
	],
	"./basket.svg": [
		73372,
		73372
	],
	"./basket2-fill.svg": [
		72296,
		72296
	],
	"./basket2.svg": [
		82182,
		82182
	],
	"./basket3-fill.svg": [
		49195,
		49195
	],
	"./basket3.svg": [
		53367,
		53367
	],
	"./battery-charging.svg": [
		95067,
		95067
	],
	"./battery-full.svg": [
		20733,
		20733
	],
	"./battery-half.svg": [
		80241,
		80241
	],
	"./battery-low.svg": [
		24348,
		24348
	],
	"./battery.svg": [
		70333,
		70333
	],
	"./beaker-fill.svg": [
		97894,
		97894
	],
	"./beaker.svg": [
		61956,
		61956
	],
	"./behance.svg": [
		35406,
		35406
	],
	"./bell-fill.svg": [
		15005,
		15005
	],
	"./bell-slash-fill.svg": [
		40369,
		40369
	],
	"./bell-slash.svg": [
		51445,
		51445
	],
	"./bell.svg": [
		14473,
		14473
	],
	"./bezier.svg": [
		55555,
		55555
	],
	"./bezier2.svg": [
		77563,
		77563
	],
	"./bicycle.svg": [
		67069,
		67069
	],
	"./bing.svg": [
		80460,
		80460
	],
	"./binoculars-fill.svg": [
		50222,
		50222
	],
	"./binoculars.svg": [
		72060,
		72060
	],
	"./blockquote-left.svg": [
		89027,
		89027
	],
	"./blockquote-right.svg": [
		41766,
		41766
	],
	"./bluesky.svg": [
		78117,
		78117
	],
	"./bluetooth.svg": [
		13064,
		13064
	],
	"./body-text.svg": [
		6346,
		6346
	],
	"./book-fill.svg": [
		91069,
		91069
	],
	"./book-half.svg": [
		41453,
		41453
	],
	"./book.svg": [
		93929,
		93929
	],
	"./bookmark-check-fill.svg": [
		78509,
		78509
	],
	"./bookmark-check.svg": [
		7513,
		7513
	],
	"./bookmark-dash-fill.svg": [
		46215,
		46215
	],
	"./bookmark-dash.svg": [
		77835,
		77835
	],
	"./bookmark-fill.svg": [
		79924,
		79924
	],
	"./bookmark-heart-fill.svg": [
		36921,
		36921
	],
	"./bookmark-heart.svg": [
		17037,
		17037
	],
	"./bookmark-plus-fill.svg": [
		26223,
		26223
	],
	"./bookmark-plus.svg": [
		47907,
		47907
	],
	"./bookmark-star-fill.svg": [
		57547,
		57547
	],
	"./bookmark-star.svg": [
		6167,
		6167
	],
	"./bookmark-x-fill.svg": [
		27397,
		27397
	],
	"./bookmark-x.svg": [
		81185,
		81185
	],
	"./bookmark.svg": [
		4058,
		4058
	],
	"./bookmarks-fill.svg": [
		21697,
		21697
	],
	"./bookmarks.svg": [
		84485,
		84485
	],
	"./bookshelf.svg": [
		50295,
		50295
	],
	"./boombox-fill.svg": [
		18072,
		18072
	],
	"./boombox.svg": [
		11798,
		11798
	],
	"./bootstrap-fill.svg": [
		31958,
		31958
	],
	"./bootstrap-reboot.svg": [
		58154,
		58154
	],
	"./bootstrap.svg": [
		7604,
		7604
	],
	"./border-all.svg": [
		77002,
		77002
	],
	"./border-bottom.svg": [
		66020,
		66020
	],
	"./border-center.svg": [
		79610,
		79610
	],
	"./border-inner.svg": [
		11663,
		11663
	],
	"./border-left.svg": [
		78638,
		78638
	],
	"./border-middle.svg": [
		51794,
		51794
	],
	"./border-outer.svg": [
		91914,
		91914
	],
	"./border-right.svg": [
		7309,
		7309
	],
	"./border-style.svg": [
		25836,
		25836
	],
	"./border-top.svg": [
		39070,
		39070
	],
	"./border-width.svg": [
		93959,
		93959
	],
	"./border.svg": [
		77348,
		77348
	],
	"./bounding-box-circles.svg": [
		86874,
		86874
	],
	"./bounding-box.svg": [
		88470,
		88470
	],
	"./box-arrow-down-left.svg": [
		18108,
		18108
	],
	"./box-arrow-down-right.svg": [
		15619,
		15619
	],
	"./box-arrow-down.svg": [
		14754,
		14754
	],
	"./box-arrow-in-down-left.svg": [
		49514,
		49514
	],
	"./box-arrow-in-down-right.svg": [
		48097,
		48097
	],
	"./box-arrow-in-down.svg": [
		11344,
		11344
	],
	"./box-arrow-in-left.svg": [
		85887,
		85887
	],
	"./box-arrow-in-right.svg": [
		2394,
		2394
	],
	"./box-arrow-in-up-left.svg": [
		67191,
		67191
	],
	"./box-arrow-in-up-right.svg": [
		14962,
		14962
	],
	"./box-arrow-in-up.svg": [
		61475,
		61475
	],
	"./box-arrow-left.svg": [
		30633,
		30633
	],
	"./box-arrow-right.svg": [
		59892,
		59892
	],
	"./box-arrow-up-left.svg": [
		16389,
		16389
	],
	"./box-arrow-up-right.svg": [
		65960,
		65960
	],
	"./box-arrow-up.svg": [
		13937,
		13937
	],
	"./box-fill.svg": [
		90005,
		90005
	],
	"./box-seam-fill.svg": [
		55702,
		55702
	],
	"./box-seam.svg": [
		80052,
		80052
	],
	"./box.svg": [
		92337,
		92337
	],
	"./box2-fill.svg": [
		93557,
		93557
	],
	"./box2-heart-fill.svg": [
		89716,
		89716
	],
	"./box2-heart.svg": [
		15930,
		15930
	],
	"./box2.svg": [
		24785,
		24785
	],
	"./boxes.svg": [
		16641,
		16641
	],
	"./braces-asterisk.svg": [
		60207,
		60207
	],
	"./braces.svg": [
		61082,
		61082
	],
	"./bricks.svg": [
		72756,
		72756
	],
	"./briefcase-fill.svg": [
		54184,
		54184
	],
	"./briefcase.svg": [
		70822,
		70822
	],
	"./brightness-alt-high-fill.svg": [
		75032,
		75032
	],
	"./brightness-alt-high.svg": [
		36278,
		36278
	],
	"./brightness-alt-low-fill.svg": [
		68626,
		68626
	],
	"./brightness-alt-low.svg": [
		40344,
		40344
	],
	"./brightness-high-fill.svg": [
		66398,
		66398
	],
	"./brightness-high.svg": [
		72204,
		72204
	],
	"./brightness-low-fill.svg": [
		16128,
		16128
	],
	"./brightness-low.svg": [
		49934,
		49934
	],
	"./brilliance.svg": [
		36873,
		36873
	],
	"./broadcast-pin.svg": [
		12601,
		12601
	],
	"./broadcast.svg": [
		63475,
		63475
	],
	"./browser-chrome.svg": [
		23937,
		23937
	],
	"./browser-edge.svg": [
		94668,
		94668
	],
	"./browser-firefox.svg": [
		58054,
		58054
	],
	"./browser-safari.svg": [
		63931,
		63931
	],
	"./brush-fill.svg": [
		86220,
		86220
	],
	"./brush.svg": [
		90562,
		90562
	],
	"./bucket-fill.svg": [
		44458,
		44458
	],
	"./bucket.svg": [
		71808,
		71808
	],
	"./bug-fill.svg": [
		66390,
		66390
	],
	"./bug.svg": [
		27892,
		27892
	],
	"./building-add.svg": [
		33068,
		33068
	],
	"./building-check.svg": [
		24749,
		24749
	],
	"./building-dash.svg": [
		36967,
		36967
	],
	"./building-down.svg": [
		95063,
		95063
	],
	"./building-exclamation.svg": [
		24074,
		24074
	],
	"./building-fill-add.svg": [
		34814,
		34814
	],
	"./building-fill-check.svg": [
		20083,
		20083
	],
	"./building-fill-dash.svg": [
		55257,
		55257
	],
	"./building-fill-down.svg": [
		57537,
		57537
	],
	"./building-fill-exclamation.svg": [
		2856,
		2856
	],
	"./building-fill-gear.svg": [
		14664,
		14664
	],
	"./building-fill-lock.svg": [
		74272,
		74272
	],
	"./building-fill-slash.svg": [
		83576,
		83576
	],
	"./building-fill-up.svg": [
		61630,
		61630
	],
	"./building-fill-x.svg": [
		34935,
		34935
	],
	"./building-fill.svg": [
		85664,
		85664
	],
	"./building-gear.svg": [
		87314,
		87314
	],
	"./building-lock.svg": [
		42390,
		42390
	],
	"./building-slash.svg": [
		55678,
		55678
	],
	"./building-up.svg": [
		48104,
		48104
	],
	"./building-x.svg": [
		21597,
		21597
	],
	"./building.svg": [
		10862,
		10862
	],
	"./buildings-fill.svg": [
		93973,
		93973
	],
	"./buildings.svg": [
		87313,
		87313
	],
	"./bullseye.svg": [
		21575,
		21575
	],
	"./bus-front-fill.svg": [
		73036,
		73036
	],
	"./bus-front.svg": [
		20802,
		20802
	],
	"./c-circle-fill.svg": [
		85556,
		85556
	],
	"./c-circle.svg": [
		4282,
		4282
	],
	"./c-square-fill.svg": [
		38819,
		38819
	],
	"./c-square.svg": [
		14527,
		14527
	],
	"./cake-fill.svg": [
		37376,
		37376
	],
	"./cake.svg": [
		6222,
		6222
	],
	"./cake2-fill.svg": [
		74346,
		74346
	],
	"./cake2.svg": [
		30464,
		30464
	],
	"./calculator-fill.svg": [
		59804,
		59804
	],
	"./calculator.svg": [
		59314,
		59314
	],
	"./calendar-check-fill.svg": [
		47015,
		47015
	],
	"./calendar-check.svg": [
		91307,
		91307
	],
	"./calendar-date-fill.svg": [
		61517,
		61517
	],
	"./calendar-date.svg": [
		73625,
		73625
	],
	"./calendar-day-fill.svg": [
		58349,
		58349
	],
	"./calendar-day.svg": [
		13190,
		90809
	],
	"./calendar-event-fill.svg": [
		53483,
		53483
	],
	"./calendar-event.svg": [
		76855,
		76855
	],
	"./calendar-fill.svg": [
		59138,
		59138
	],
	"./calendar-heart-fill.svg": [
		46643,
		46643
	],
	"./calendar-heart.svg": [
		89039,
		89039
	],
	"./calendar-minus-fill.svg": [
		68499,
		68499
	],
	"./calendar-minus.svg": [
		71951,
		71951
	],
	"./calendar-month-fill.svg": [
		28701,
		28701
	],
	"./calendar-month.svg": [
		67785,
		67785
	],
	"./calendar-plus-fill.svg": [
		15109,
		15109
	],
	"./calendar-plus.svg": [
		21313,
		21313
	],
	"./calendar-range-fill.svg": [
		30902,
		30902
	],
	"./calendar-range.svg": [
		43892,
		43892
	],
	"./calendar-week-fill.svg": [
		97633,
		97633
	],
	"./calendar-week.svg": [
		1125,
		1125
	],
	"./calendar-x-fill.svg": [
		88899,
		88899
	],
	"./calendar-x.svg": [
		14335,
		14335
	],
	"./calendar.svg": [
		21384,
		21384
	],
	"./calendar2-check-fill.svg": [
		32061,
		32061
	],
	"./calendar2-check.svg": [
		20489,
		20489
	],
	"./calendar2-date-fill.svg": [
		7795,
		7795
	],
	"./calendar2-date.svg": [
		50671,
		50671
	],
	"./calendar2-day-fill.svg": [
		19079,
		19079
	],
	"./calendar2-day.svg": [
		18859,
		18859
	],
	"./calendar2-event-fill.svg": [
		44053,
		44053
	],
	"./calendar2-event.svg": [
		52625,
		52625
	],
	"./calendar2-fill.svg": [
		61348,
		61348
	],
	"./calendar2-heart-fill.svg": [
		66473,
		66473
	],
	"./calendar2-heart.svg": [
		25309,
		25309
	],
	"./calendar2-minus-fill.svg": [
		22773,
		22773
	],
	"./calendar2-minus.svg": [
		89233,
		89233
	],
	"./calendar2-month-fill.svg": [
		40359,
		40359
	],
	"./calendar2-month.svg": [
		78635,
		78635
	],
	"./calendar2-plus-fill.svg": [
		81023,
		81023
	],
	"./calendar2-plus.svg": [
		90035,
		90035
	],
	"./calendar2-range-fill.svg": [
		21068,
		21068
	],
	"./calendar2-range.svg": [
		43106,
		43106
	],
	"./calendar2-week-fill.svg": [
		2559,
		2559
	],
	"./calendar2-week.svg": [
		26963,
		26963
	],
	"./calendar2-x-fill.svg": [
		62613,
		62613
	],
	"./calendar2-x.svg": [
		10321,
		10321
	],
	"./calendar2.svg": [
		42,
		42
	],
	"./calendar3-event-fill.svg": [
		74670,
		74670
	],
	"./calendar3-event.svg": [
		98620,
		98620
	],
	"./calendar3-fill.svg": [
		5495,
		5495
	],
	"./calendar3-range-fill.svg": [
		39503,
		39503
	],
	"./calendar3-range.svg": [
		5315,
		5315
	],
	"./calendar3-week-fill.svg": [
		55970,
		55970
	],
	"./calendar3-week.svg": [
		63368,
		63368
	],
	"./calendar3.svg": [
		17883,
		17883
	],
	"./calendar4-event.svg": [
		17923,
		17923
	],
	"./calendar4-range.svg": [
		48272,
		48272
	],
	"./calendar4-week.svg": [
		32649,
		32649
	],
	"./calendar4.svg": [
		84820,
		84820
	],
	"./camera-fill.svg": [
		76771,
		76771
	],
	"./camera-reels-fill.svg": [
		21199,
		21199
	],
	"./camera-reels.svg": [
		80611,
		80611
	],
	"./camera-video-fill.svg": [
		60317,
		60317
	],
	"./camera-video-off-fill.svg": [
		95241,
		95241
	],
	"./camera-video-off.svg": [
		59069,
		59069
	],
	"./camera-video.svg": [
		5993,
		5993
	],
	"./camera.svg": [
		63295,
		63295
	],
	"./camera2.svg": [
		54767,
		54767
	],
	"./capslock-fill.svg": [
		14090,
		14090
	],
	"./capslock.svg": [
		80736,
		80736
	],
	"./capsule-pill.svg": [
		84797,
		84797
	],
	"./capsule.svg": [
		31259,
		31259
	],
	"./car-front-fill.svg": [
		89900,
		89900
	],
	"./car-front.svg": [
		85186,
		85186
	],
	"./card-checklist.svg": [
		58339,
		58339
	],
	"./card-heading.svg": [
		87373,
		87373
	],
	"./card-image.svg": [
		12864,
		12864
	],
	"./card-list.svg": [
		73953,
		73953
	],
	"./card-text.svg": [
		87820,
		87820
	],
	"./caret-down-fill.svg": [
		28722,
		28722
	],
	"./caret-down-square-fill.svg": [
		57106,
		57106
	],
	"./caret-down-square.svg": [
		92280,
		92280
	],
	"./caret-down.svg": [
		85592,
		63211
	],
	"./caret-left-fill.svg": [
		19627,
		19627
	],
	"./caret-left-square-fill.svg": [
		297,
		297
	],
	"./caret-left-square.svg": [
		33853,
		33853
	],
	"./caret-left.svg": [
		90135,
		90135
	],
	"./caret-right-fill.svg": [
		26396,
		26396
	],
	"./caret-right-square-fill.svg": [
		94240,
		94240
	],
	"./caret-right-square.svg": [
		67118,
		67118
	],
	"./caret-right.svg": [
		46930,
		46930
	],
	"./caret-up-fill.svg": [
		50631,
		50631
	],
	"./caret-up-square-fill.svg": [
		34101,
		34101
	],
	"./caret-up-square.svg": [
		14065,
		14065
	],
	"./caret-up.svg": [
		55883,
		55883
	],
	"./cart-check-fill.svg": [
		95147,
		17528
	],
	"./cart-check.svg": [
		48727,
		48727
	],
	"./cart-dash-fill.svg": [
		62721,
		62721
	],
	"./cart-dash.svg": [
		86885,
		86885
	],
	"./cart-fill.svg": [
		48838,
		48838
	],
	"./cart-plus-fill.svg": [
		90217,
		90217
	],
	"./cart-plus.svg": [
		84029,
		84029
	],
	"./cart-x-fill.svg": [
		5295,
		5295
	],
	"./cart-x.svg": [
		80515,
		80515
	],
	"./cart.svg": [
		19172,
		19172
	],
	"./cart2.svg": [
		98622,
		98622
	],
	"./cart3.svg": [
		42351,
		42351
	],
	"./cart4.svg": [
		76464,
		76464
	],
	"./cash-coin.svg": [
		84579,
		84579
	],
	"./cash-stack.svg": [
		55012,
		55012
	],
	"./cash.svg": [
		76979,
		76979
	],
	"./cassette-fill.svg": [
		55804,
		55804
	],
	"./cassette.svg": [
		57650,
		57650
	],
	"./cast.svg": [
		36647,
		36647
	],
	"./cc-circle-fill.svg": [
		90309,
		90309
	],
	"./cc-circle.svg": [
		25486,
		25486
	],
	"./cc-square-fill.svg": [
		59270,
		59270
	],
	"./cc-square.svg": [
		83396,
		83396
	],
	"./chat-dots-fill.svg": [
		37805,
		37805
	],
	"./chat-dots.svg": [
		58297,
		58297
	],
	"./chat-fill.svg": [
		54386,
		54386
	],
	"./chat-heart-fill.svg": [
		56483,
		56483
	],
	"./chat-heart.svg": [
		99615,
		99615
	],
	"./chat-left-dots-fill.svg": [
		14283,
		14283
	],
	"./chat-left-dots.svg": [
		35223,
		35223
	],
	"./chat-left-fill.svg": [
		58988,
		58988
	],
	"./chat-left-heart-fill.svg": [
		2577,
		2577
	],
	"./chat-left-heart.svg": [
		47349,
		47349
	],
	"./chat-left-quote-fill.svg": [
		30445,
		30445
	],
	"./chat-left-quote.svg": [
		34905,
		34905
	],
	"./chat-left-text-fill.svg": [
		87856,
		87856
	],
	"./chat-left-text.svg": [
		74430,
		74430
	],
	"./chat-left.svg": [
		45890,
		45890
	],
	"./chat-quote-fill.svg": [
		74815,
		74815
	],
	"./chat-quote.svg": [
		83283,
		83283
	],
	"./chat-right-dots-fill.svg": [
		40132,
		40132
	],
	"./chat-right-dots.svg": [
		23146,
		23146
	],
	"./chat-right-fill.svg": [
		62765,
		62765
	],
	"./chat-right-heart-fill.svg": [
		67116,
		67116
	],
	"./chat-right-heart.svg": [
		92418,
		92418
	],
	"./chat-right-quote-fill.svg": [
		99092,
		99092
	],
	"./chat-right-quote.svg": [
		51738,
		51738
	],
	"./chat-right-text-fill.svg": [
		3151,
		3151
	],
	"./chat-right-text.svg": [
		15075,
		15075
	],
	"./chat-right.svg": [
		62521,
		62521
	],
	"./chat-square-dots-fill.svg": [
		81389,
		81389
	],
	"./chat-square-dots.svg": [
		75865,
		75865
	],
	"./chat-square-fill.svg": [
		71954,
		71954
	],
	"./chat-square-heart-fill.svg": [
		49059,
		49059
	],
	"./chat-square-heart.svg": [
		63135,
		63135
	],
	"./chat-square-quote-fill.svg": [
		83743,
		83743
	],
	"./chat-square-quote.svg": [
		46803,
		46803
	],
	"./chat-square-text-fill.svg": [
		88498,
		88498
	],
	"./chat-square-text.svg": [
		89080,
		89080
	],
	"./chat-square.svg": [
		2392,
		2392
	],
	"./chat-text-fill.svg": [
		28562,
		28562
	],
	"./chat-text.svg": [
		55160,
		55160
	],
	"./chat.svg": [
		42936,
		42936
	],
	"./check-all.svg": [
		36776,
		36776
	],
	"./check-circle-fill.svg": [
		61875,
		61875
	],
	"./check-circle.svg": [
		54703,
		54703
	],
	"./check-lg.svg": [
		85536,
		85536
	],
	"./check-square-fill.svg": [
		69808,
		69808
	],
	"./check-square.svg": [
		11710,
		11710
	],
	"./check.svg": [
		94082,
		94082
	],
	"./check2-all.svg": [
		33618,
		33618
	],
	"./check2-circle.svg": [
		49225,
		49225
	],
	"./check2-square.svg": [
		60652,
		60652
	],
	"./check2.svg": [
		23004,
		23004
	],
	"./chevron-bar-contract.svg": [
		55306,
		55306
	],
	"./chevron-bar-down.svg": [
		75112,
		75112
	],
	"./chevron-bar-expand.svg": [
		10876,
		10876
	],
	"./chevron-bar-left.svg": [
		42887,
		42887
	],
	"./chevron-bar-right.svg": [
		16770,
		16770
	],
	"./chevron-bar-up.svg": [
		42811,
		42811
	],
	"./chevron-compact-down.svg": [
		14944,
		14944
	],
	"./chevron-compact-left.svg": [
		68687,
		68687
	],
	"./chevron-compact-right.svg": [
		5866,
		5866
	],
	"./chevron-compact-up.svg": [
		62131,
		62131
	],
	"./chevron-contract.svg": [
		4602,
		4602
	],
	"./chevron-double-down.svg": [
		42640,
		42640
	],
	"./chevron-double-left.svg": [
		3391,
		3391
	],
	"./chevron-double-right.svg": [
		91482,
		91482
	],
	"./chevron-double-up.svg": [
		21667,
		21667
	],
	"./chevron-down.svg": [
		67992,
		67992
	],
	"./chevron-expand.svg": [
		74444,
		74444
	],
	"./chevron-left.svg": [
		78519,
		78519
	],
	"./chevron-right.svg": [
		53266,
		53266
	],
	"./chevron-up.svg": [
		82443,
		82443
	],
	"./circle-fill.svg": [
		37828,
		37828
	],
	"./circle-half.svg": [
		74312,
		74312
	],
	"./circle-square.svg": [
		60166,
		60166
	],
	"./circle.svg": [
		4394,
		4394
	],
	"./claude.svg": [
		40804,
		40804
	],
	"./clipboard-check-fill.svg": [
		21679,
		21679
	],
	"./clipboard-check.svg": [
		89379,
		89379
	],
	"./clipboard-data-fill.svg": [
		50505,
		50505
	],
	"./clipboard-data.svg": [
		56861,
		56861
	],
	"./clipboard-fill.svg": [
		79898,
		79898
	],
	"./clipboard-heart-fill.svg": [
		37931,
		37931
	],
	"./clipboard-heart.svg": [
		56343,
		56343
	],
	"./clipboard-minus-fill.svg": [
		17528,
		95147
	],
	"./clipboard-minus.svg": [
		30039,
		30039
	],
	"./clipboard-plus-fill.svg": [
		30381,
		30381
	],
	"./clipboard-plus.svg": [
		2425,
		2425
	],
	"./clipboard-pulse.svg": [
		36240,
		36240
	],
	"./clipboard-x-fill.svg": [
		44027,
		44027
	],
	"./clipboard-x.svg": [
		37959,
		37959
	],
	"./clipboard.svg": [
		89488,
		89488
	],
	"./clipboard2-check-fill.svg": [
		85045,
		85045
	],
	"./clipboard2-check.svg": [
		65041,
		65041
	],
	"./clipboard2-data-fill.svg": [
		81911,
		81911
	],
	"./clipboard2-data.svg": [
		90363,
		90363
	],
	"./clipboard2-fill.svg": [
		95212,
		95212
	],
	"./clipboard2-heart-fill.svg": [
		46545,
		46545
	],
	"./clipboard2-heart.svg": [
		23605,
		23605
	],
	"./clipboard2-minus-fill.svg": [
		53917,
		53917
	],
	"./clipboard2-minus.svg": [
		8393,
		8393
	],
	"./clipboard2-plus-fill.svg": [
		80471,
		80471
	],
	"./clipboard2-plus.svg": [
		67899,
		67899
	],
	"./clipboard2-pulse-fill.svg": [
		88616,
		88616
	],
	"./clipboard2-pulse.svg": [
		49030,
		49030
	],
	"./clipboard2-x-fill.svg": [
		89629,
		89629
	],
	"./clipboard2-x.svg": [
		809,
		809
	],
	"./clipboard2.svg": [
		27874,
		27874
	],
	"./clock-fill.svg": [
		9938,
		9938
	],
	"./clock-history.svg": [
		54155,
		54155
	],
	"./clock.svg": [
		12088,
		12088
	],
	"./cloud-arrow-down-fill.svg": [
		6860,
		6860
	],
	"./cloud-arrow-down.svg": [
		63714,
		63714
	],
	"./cloud-arrow-up-fill.svg": [
		76917,
		76917
	],
	"./cloud-arrow-up.svg": [
		14801,
		14801
	],
	"./cloud-check-fill.svg": [
		56936,
		56936
	],
	"./cloud-check.svg": [
		91014,
		91014
	],
	"./cloud-download-fill.svg": [
		90664,
		90664
	],
	"./cloud-download.svg": [
		48198,
		48198
	],
	"./cloud-drizzle-fill.svg": [
		76690,
		76690
	],
	"./cloud-drizzle.svg": [
		48504,
		48504
	],
	"./cloud-fill.svg": [
		49301,
		49301
	],
	"./cloud-fog-fill.svg": [
		41408,
		41408
	],
	"./cloud-fog.svg": [
		69998,
		69998
	],
	"./cloud-fog2-fill.svg": [
		23754,
		23754
	],
	"./cloud-fog2.svg": [
		54656,
		54656
	],
	"./cloud-hail-fill.svg": [
		37314,
		37314
	],
	"./cloud-hail.svg": [
		17960,
		17960
	],
	"./cloud-haze-fill.svg": [
		60610,
		60610
	],
	"./cloud-haze.svg": [
		84872,
		84872
	],
	"./cloud-haze2-fill.svg": [
		23972,
		23972
	],
	"./cloud-haze2.svg": [
		53194,
		53194
	],
	"./cloud-lightning-fill.svg": [
		56530,
		56530
	],
	"./cloud-lightning-rain-fill.svg": [
		48235,
		48235
	],
	"./cloud-lightning-rain.svg": [
		48663,
		48663
	],
	"./cloud-lightning.svg": [
		92600,
		92600
	],
	"./cloud-minus-fill.svg": [
		55836,
		55836
	],
	"./cloud-minus.svg": [
		84530,
		84530
	],
	"./cloud-moon-fill.svg": [
		3697,
		3697
	],
	"./cloud-moon.svg": [
		3349,
		3349
	],
	"./cloud-plus-fill.svg": [
		27988,
		27988
	],
	"./cloud-plus.svg": [
		12986,
		12986
	],
	"./cloud-rain-fill.svg": [
		84994,
		84994
	],
	"./cloud-rain-heavy-fill.svg": [
		70800,
		70800
	],
	"./cloud-rain-heavy.svg": [
		38718,
		38718
	],
	"./cloud-rain.svg": [
		38472,
		38472
	],
	"./cloud-slash-fill.svg": [
		28601,
		28601
	],
	"./cloud-slash.svg": [
		86253,
		86253
	],
	"./cloud-sleet-fill.svg": [
		80711,
		80711
	],
	"./cloud-sleet.svg": [
		61643,
		61643
	],
	"./cloud-snow-fill.svg": [
		10051,
		10051
	],
	"./cloud-snow.svg": [
		84959,
		84959
	],
	"./cloud-sun-fill.svg": [
		22190,
		22190
	],
	"./cloud-sun.svg": [
		17308,
		17308
	],
	"./cloud-upload-fill.svg": [
		83273,
		83273
	],
	"./cloud-upload.svg": [
		23581,
		23581
	],
	"./cloud.svg": [
		98481,
		98481
	],
	"./clouds-fill.svg": [
		1002,
		1002
	],
	"./clouds.svg": [
		65728,
		65728
	],
	"./cloudy-fill.svg": [
		27124,
		27124
	],
	"./cloudy.svg": [
		25786,
		25786
	],
	"./code-slash.svg": [
		45509,
		45509
	],
	"./code-square.svg": [
		60011,
		60011
	],
	"./code.svg": [
		22361,
		22361
	],
	"./coin.svg": [
		48829,
		48829
	],
	"./collection-fill.svg": [
		276,
		276
	],
	"./collection-play-fill.svg": [
		74745,
		74745
	],
	"./collection-play.svg": [
		11181,
		11181
	],
	"./collection.svg": [
		9818,
		9818
	],
	"./columns-gap.svg": [
		17892,
		17892
	],
	"./columns.svg": [
		9943,
		9943
	],
	"./command.svg": [
		9493,
		9493
	],
	"./compass-fill.svg": [
		21544,
		21544
	],
	"./compass.svg": [
		4870,
		4870
	],
	"./cone-striped.svg": [
		68405,
		68405
	],
	"./cone.svg": [
		15079,
		15079
	],
	"./controller.svg": [
		96754,
		96754
	],
	"./cookie.svg": [
		61964,
		61964
	],
	"./copy.svg": [
		88409,
		88409
	],
	"./cpu-fill.svg": [
		29714,
		29714
	],
	"./cpu.svg": [
		6552,
		6552
	],
	"./credit-card-2-back-fill.svg": [
		18091,
		18091
	],
	"./credit-card-2-back.svg": [
		73559,
		73559
	],
	"./credit-card-2-front-fill.svg": [
		7311,
		7311
	],
	"./credit-card-2-front.svg": [
		22339,
		22339
	],
	"./credit-card-fill.svg": [
		32626,
		32626
	],
	"./credit-card.svg": [
		824,
		824
	],
	"./crop.svg": [
		58184,
		58184
	],
	"./crosshair.svg": [
		99354,
		99354
	],
	"./crosshair2.svg": [
		36100,
		36100
	],
	"./css.svg": [
		19823,
		19823
	],
	"./cup-fill.svg": [
		51432,
		51432
	],
	"./cup-hot-fill.svg": [
		95318,
		95318
	],
	"./cup-hot.svg": [
		64852,
		64852
	],
	"./cup-straw.svg": [
		31132,
		31132
	],
	"./cup.svg": [
		50182,
		50182
	],
	"./currency-bitcoin.svg": [
		96346,
		96346
	],
	"./currency-dollar.svg": [
		98330,
		98330
	],
	"./currency-euro.svg": [
		9467,
		9467
	],
	"./currency-exchange.svg": [
		75911,
		75911
	],
	"./currency-pound.svg": [
		29006,
		29006
	],
	"./currency-rupee.svg": [
		45287,
		45287
	],
	"./currency-yen.svg": [
		66796,
		66796
	],
	"./cursor-fill.svg": [
		96790,
		96790
	],
	"./cursor-text.svg": [
		1164,
		1164
	],
	"./cursor.svg": [
		81108,
		81108
	],
	"./dash-circle-dotted.svg": [
		38320,
		38320
	],
	"./dash-circle-fill.svg": [
		64987,
		64987
	],
	"./dash-circle.svg": [
		91175,
		91175
	],
	"./dash-lg.svg": [
		77800,
		77800
	],
	"./dash-square-dotted.svg": [
		94935,
		94935
	],
	"./dash-square-fill.svg": [
		60984,
		60984
	],
	"./dash-square.svg": [
		57686,
		57686
	],
	"./dash.svg": [
		99386,
		99386
	],
	"./database-add.svg": [
		2563,
		2563
	],
	"./database-check.svg": [
		51246,
		51246
	],
	"./database-dash.svg": [
		49054,
		49054
	],
	"./database-down.svg": [
		54470,
		54470
	],
	"./database-exclamation.svg": [
		37305,
		37305
	],
	"./database-fill-add.svg": [
		58191,
		58191
	],
	"./database-fill-check.svg": [
		81666,
		81666
	],
	"./database-fill-dash.svg": [
		34938,
		34938
	],
	"./database-fill-down.svg": [
		77290,
		77290
	],
	"./database-fill-exclamation.svg": [
		98725,
		98725
	],
	"./database-fill-gear.svg": [
		87467,
		87467
	],
	"./database-fill-lock.svg": [
		43307,
		43307
	],
	"./database-fill-slash.svg": [
		92137,
		92137
	],
	"./database-fill-up.svg": [
		40537,
		40537
	],
	"./database-fill-x.svg": [
		61398,
		61398
	],
	"./database-fill.svg": [
		22685,
		22685
	],
	"./database-gear.svg": [
		26023,
		26023
	],
	"./database-lock.svg": [
		39799,
		39799
	],
	"./database-slash.svg": [
		27573,
		27573
	],
	"./database-up.svg": [
		19741,
		19741
	],
	"./database-x.svg": [
		13306,
		13306
	],
	"./database.svg": [
		91081,
		91081
	],
	"./device-hdd-fill.svg": [
		36467,
		36467
	],
	"./device-hdd.svg": [
		18511,
		18511
	],
	"./device-ssd-fill.svg": [
		66069,
		66069
	],
	"./device-ssd.svg": [
		21457,
		21457
	],
	"./diagram-2-fill.svg": [
		41270,
		41270
	],
	"./diagram-2.svg": [
		27444,
		27444
	],
	"./diagram-3-fill.svg": [
		93841,
		93841
	],
	"./diagram-3.svg": [
		53077,
		53077
	],
	"./diamond-fill.svg": [
		16252,
		16252
	],
	"./diamond-half.svg": [
		45776,
		45776
	],
	"./diamond.svg": [
		15730,
		15730
	],
	"./dice-1-fill.svg": [
		20773,
		20773
	],
	"./dice-1.svg": [
		21505,
		21505
	],
	"./dice-2-fill.svg": [
		21724,
		21724
	],
	"./dice-2.svg": [
		39762,
		39762
	],
	"./dice-3-fill.svg": [
		29263,
		29263
	],
	"./dice-3.svg": [
		72803,
		72803
	],
	"./dice-4-fill.svg": [
		50414,
		50414
	],
	"./dice-4.svg": [
		45148,
		45148
	],
	"./dice-5-fill.svg": [
		21801,
		21801
	],
	"./dice-5.svg": [
		73693,
		73693
	],
	"./dice-6-fill.svg": [
		39408,
		39408
	],
	"./dice-6.svg": [
		61598,
		61598
	],
	"./disc-fill.svg": [
		95069,
		95069
	],
	"./disc.svg": [
		13033,
		13033
	],
	"./discord.svg": [
		61494,
		61494
	],
	"./display-fill.svg": [
		13686,
		13686
	],
	"./display.svg": [
		5332,
		5332
	],
	"./displayport-fill.svg": [
		93350,
		70969
	],
	"./displayport.svg": [
		82541,
		82541
	],
	"./distribute-horizontal.svg": [
		64056,
		64056
	],
	"./distribute-vertical.svg": [
		12046,
		12046
	],
	"./door-closed-fill.svg": [
		45555,
		45555
	],
	"./door-closed.svg": [
		44751,
		44751
	],
	"./door-open-fill.svg": [
		89535,
		89535
	],
	"./door-open.svg": [
		72435,
		72435
	],
	"./dot.svg": [
		59591,
		59591
	],
	"./download.svg": [
		29514,
		29514
	],
	"./dpad-fill.svg": [
		99537,
		99537
	],
	"./dpad.svg": [
		95957,
		95957
	],
	"./dribbble.svg": [
		27852,
		27852
	],
	"./dropbox.svg": [
		3820,
		3820
	],
	"./droplet-fill.svg": [
		40702,
		40702
	],
	"./droplet-half.svg": [
		32962,
		32962
	],
	"./droplet.svg": [
		40364,
		40364
	],
	"./duffle-fill.svg": [
		76444,
		76444
	],
	"./duffle.svg": [
		70770,
		70770
	],
	"./ear-fill.svg": [
		75364,
		75364
	],
	"./ear.svg": [
		67722,
		67722
	],
	"./earbuds.svg": [
		22462,
		22462
	],
	"./easel-fill.svg": [
		29386,
		29386
	],
	"./easel.svg": [
		96032,
		96032
	],
	"./easel2-fill.svg": [
		48124,
		48124
	],
	"./easel2.svg": [
		11122,
		11122
	],
	"./easel3-fill.svg": [
		33775,
		33775
	],
	"./easel3.svg": [
		25763,
		25763
	],
	"./egg-fill.svg": [
		9777,
		9777
	],
	"./egg-fried.svg": [
		21580,
		21580
	],
	"./egg.svg": [
		4309,
		4309
	],
	"./eject-fill.svg": [
		79461,
		79461
	],
	"./eject.svg": [
		51521,
		51521
	],
	"./emoji-angry-fill.svg": [
		94050,
		94050
	],
	"./emoji-angry.svg": [
		84616,
		84616
	],
	"./emoji-astonished-fill.svg": [
		24839,
		24839
	],
	"./emoji-astonished.svg": [
		27467,
		27467
	],
	"./emoji-dizzy-fill.svg": [
		24873,
		24873
	],
	"./emoji-dizzy.svg": [
		19069,
		19069
	],
	"./emoji-expressionless-fill.svg": [
		5006,
		5006
	],
	"./emoji-expressionless.svg": [
		78908,
		78908
	],
	"./emoji-frown-fill.svg": [
		87699,
		87699
	],
	"./emoji-frown.svg": [
		55823,
		55823
	],
	"./emoji-grimace-fill.svg": [
		56553,
		56553
	],
	"./emoji-grimace.svg": [
		12893,
		12893
	],
	"./emoji-grin-fill.svg": [
		21375,
		21375
	],
	"./emoji-grin.svg": [
		5587,
		5587
	],
	"./emoji-heart-eyes-fill.svg": [
		8528,
		8528
	],
	"./emoji-heart-eyes.svg": [
		95358,
		95358
	],
	"./emoji-kiss-fill.svg": [
		65243,
		65243
	],
	"./emoji-kiss.svg": [
		21703,
		21703
	],
	"./emoji-laughing-fill.svg": [
		37858,
		37858
	],
	"./emoji-laughing.svg": [
		28200,
		28200
	],
	"./emoji-neutral-fill.svg": [
		31996,
		31996
	],
	"./emoji-neutral.svg": [
		14162,
		14162
	],
	"./emoji-smile-fill.svg": [
		82191,
		82191
	],
	"./emoji-smile-upside-down-fill.svg": [
		4707,
		4707
	],
	"./emoji-smile-upside-down.svg": [
		55999,
		55999
	],
	"./emoji-smile.svg": [
		21635,
		21635
	],
	"./emoji-sunglasses-fill.svg": [
		70471,
		70471
	],
	"./emoji-sunglasses.svg": [
		84024,
		84024
	],
	"./emoji-surprise-fill.svg": [
		86582,
		64201
	],
	"./emoji-surprise.svg": [
		87252,
		87252
	],
	"./emoji-tear-fill.svg": [
		99745,
		99745
	],
	"./emoji-tear.svg": [
		50309,
		50309
	],
	"./emoji-wink-fill.svg": [
		9246,
		9246
	],
	"./emoji-wink.svg": [
		98988,
		98988
	],
	"./envelope-arrow-down-fill.svg": [
		43019,
		43019
	],
	"./envelope-arrow-down.svg": [
		39351,
		39351
	],
	"./envelope-arrow-up-fill.svg": [
		73794,
		73794
	],
	"./envelope-arrow-up.svg": [
		49608,
		49608
	],
	"./envelope-at-fill.svg": [
		29638,
		29638
	],
	"./envelope-at.svg": [
		75300,
		75300
	],
	"./envelope-check-fill.svg": [
		97869,
		97869
	],
	"./envelope-check.svg": [
		55801,
		55801
	],
	"./envelope-dash-fill.svg": [
		21639,
		21639
	],
	"./envelope-dash.svg": [
		70923,
		70923
	],
	"./envelope-exclamation-fill.svg": [
		79600,
		79600
	],
	"./envelope-exclamation.svg": [
		91166,
		91166
	],
	"./envelope-fill.svg": [
		82836,
		82836
	],
	"./envelope-heart-fill.svg": [
		47961,
		47961
	],
	"./envelope-heart.svg": [
		77005,
		77005
	],
	"./envelope-open-fill.svg": [
		75411,
		75411
	],
	"./envelope-open-heart-fill.svg": [
		5062,
		5062
	],
	"./envelope-open-heart.svg": [
		84228,
		84228
	],
	"./envelope-open.svg": [
		73199,
		73199
	],
	"./envelope-paper-fill.svg": [
		48475,
		48475
	],
	"./envelope-paper-heart-fill.svg": [
		57550,
		57550
	],
	"./envelope-paper-heart.svg": [
		96604,
		96604
	],
	"./envelope-paper.svg": [
		34215,
		34215
	],
	"./envelope-plus-fill.svg": [
		62652,
		40271
	],
	"./envelope-plus.svg": [
		40995,
		40995
	],
	"./envelope-slash-fill.svg": [
		12596,
		12596
	],
	"./envelope-slash.svg": [
		16250,
		16250
	],
	"./envelope-x-fill.svg": [
		72677,
		72677
	],
	"./envelope-x.svg": [
		9313,
		9313
	],
	"./envelope.svg": [
		4756,
		59994
	],
	"./eraser-fill.svg": [
		29184,
		29184
	],
	"./eraser.svg": [
		27022,
		27022
	],
	"./escape.svg": [
		53363,
		53363
	],
	"./ethernet.svg": [
		39931,
		39931
	],
	"./ev-front-fill.svg": [
		32513,
		32513
	],
	"./ev-front.svg": [
		66021,
		66021
	],
	"./ev-station-fill.svg": [
		90606,
		90606
	],
	"./ev-station.svg": [
		21596,
		21596
	],
	"./exclamation-circle-fill.svg": [
		66588,
		66588
	],
	"./exclamation-circle.svg": [
		51922,
		51922
	],
	"./exclamation-diamond-fill.svg": [
		76580,
		76580
	],
	"./exclamation-diamond.svg": [
		64413,
		86794
	],
	"./exclamation-lg.svg": [
		61905,
		61905
	],
	"./exclamation-octagon-fill.svg": [
		1055,
		1055
	],
	"./exclamation-octagon.svg": [
		23283,
		23283
	],
	"./exclamation-square-fill.svg": [
		48107,
		48107
	],
	"./exclamation-square.svg": [
		26807,
		26807
	],
	"./exclamation-triangle-fill.svg": [
		42948,
		42948
	],
	"./exclamation-triangle.svg": [
		55818,
		55818
	],
	"./exclamation.svg": [
		30821,
		30821
	],
	"./exclude.svg": [
		36176,
		36176
	],
	"./explicit-fill.svg": [
		66420,
		66420
	],
	"./explicit.svg": [
		98362,
		98362
	],
	"./exposure.svg": [
		22109,
		22109
	],
	"./eye-fill.svg": [
		55961,
		55961
	],
	"./eye-slash-fill.svg": [
		39418,
		39418
	],
	"./eye-slash.svg": [
		20761,
		20761
	],
	"./eye.svg": [
		80173,
		80173
	],
	"./eyedropper.svg": [
		36207,
		36207
	],
	"./eyeglasses.svg": [
		54635,
		54635
	],
	"./facebook.svg": [
		49734,
		49734
	],
	"./fan.svg": [
		54069,
		54069
	],
	"./fast-forward-btn-fill.svg": [
		95267,
		95267
	],
	"./fast-forward-btn.svg": [
		35679,
		35679
	],
	"./fast-forward-circle-fill.svg": [
		72849,
		72849
	],
	"./fast-forward-circle.svg": [
		93237,
		93237
	],
	"./fast-forward-fill.svg": [
		92578,
		92578
	],
	"./fast-forward.svg": [
		60424,
		60424
	],
	"./feather.svg": [
		59243,
		59243
	],
	"./feather2.svg": [
		59571,
		59571
	],
	"./file-arrow-down-fill.svg": [
		90529,
		90529
	],
	"./file-arrow-down.svg": [
		62917,
		62917
	],
	"./file-arrow-up-fill.svg": [
		14180,
		14180
	],
	"./file-arrow-up.svg": [
		87530,
		87530
	],
	"./file-bar-graph-fill.svg": [
		41179,
		41179
	],
	"./file-bar-graph.svg": [
		5767,
		5767
	],
	"./file-binary-fill.svg": [
		57976,
		57976
	],
	"./file-binary.svg": [
		3510,
		3510
	],
	"./file-break-fill.svg": [
		56200,
		56200
	],
	"./file-break.svg": [
		6662,
		6662
	],
	"./file-check-fill.svg": [
		61695,
		61695
	],
	"./file-check.svg": [
		45715,
		45715
	],
	"./file-code-fill.svg": [
		55644,
		55644
	],
	"./file-code.svg": [
		84018,
		84018
	],
	"./file-diff-fill.svg": [
		12750,
		12750
	],
	"./file-diff.svg": [
		34716,
		34716
	],
	"./file-earmark-arrow-down-fill.svg": [
		90817,
		90817
	],
	"./file-earmark-arrow-down.svg": [
		16581,
		16581
	],
	"./file-earmark-arrow-up-fill.svg": [
		98660,
		98660
	],
	"./file-earmark-arrow-up.svg": [
		70090,
		70090
	],
	"./file-earmark-bar-graph-fill.svg": [
		27259,
		27259
	],
	"./file-earmark-bar-graph.svg": [
		1895,
		1895
	],
	"./file-earmark-binary-fill.svg": [
		56888,
		56888
	],
	"./file-earmark-binary.svg": [
		63414,
		63414
	],
	"./file-earmark-break-fill.svg": [
		65256,
		65256
	],
	"./file-earmark-break.svg": [
		91238,
		91238
	],
	"./file-earmark-check-fill.svg": [
		81471,
		81471
	],
	"./file-earmark-check.svg": [
		64915,
		64915
	],
	"./file-earmark-code-fill.svg": [
		64156,
		64156
	],
	"./file-earmark-code.svg": [
		51762,
		51762
	],
	"./file-earmark-diff-fill.svg": [
		33198,
		33198
	],
	"./file-earmark-diff.svg": [
		7068,
		7068
	],
	"./file-earmark-easel-fill.svg": [
		99341,
		99341
	],
	"./file-earmark-easel.svg": [
		6137,
		6137
	],
	"./file-earmark-excel-fill.svg": [
		44192,
		44192
	],
	"./file-earmark-excel.svg": [
		47118,
		47118
	],
	"./file-earmark-fill.svg": [
		77514,
		77514
	],
	"./file-earmark-font-fill.svg": [
		95764,
		95764
	],
	"./file-earmark-font.svg": [
		8026,
		8026
	],
	"./file-earmark-image-fill.svg": [
		85950,
		85950
	],
	"./file-earmark-image.svg": [
		7660,
		7660
	],
	"./file-earmark-lock-fill.svg": [
		22474,
		22474
	],
	"./file-earmark-lock.svg": [
		52896,
		52896
	],
	"./file-earmark-lock2-fill.svg": [
		47612,
		47612
	],
	"./file-earmark-lock2.svg": [
		67666,
		67666
	],
	"./file-earmark-medical-fill.svg": [
		12532,
		12532
	],
	"./file-earmark-medical.svg": [
		14650,
		14650
	],
	"./file-earmark-minus-fill.svg": [
		92667,
		92667
	],
	"./file-earmark-minus.svg": [
		53319,
		53319
	],
	"./file-earmark-music-fill.svg": [
		78184,
		78184
	],
	"./file-earmark-music.svg": [
		66918,
		66918
	],
	"./file-earmark-pdf-fill.svg": [
		68809,
		68809
	],
	"./file-earmark-pdf.svg": [
		68253,
		68253
	],
	"./file-earmark-person-fill.svg": [
		51512,
		51512
	],
	"./file-earmark-person.svg": [
		60534,
		60534
	],
	"./file-earmark-play-fill.svg": [
		24643,
		24643
	],
	"./file-earmark-play.svg": [
		54239,
		54239
	],
	"./file-earmark-plus-fill.svg": [
		88829,
		88829
	],
	"./file-earmark-plus.svg": [
		76457,
		76457
	],
	"./file-earmark-post-fill.svg": [
		42463,
		42463
	],
	"./file-earmark-post.svg": [
		93843,
		93843
	],
	"./file-earmark-ppt-fill.svg": [
		2743,
		2743
	],
	"./file-earmark-ppt.svg": [
		65371,
		65371
	],
	"./file-earmark-richtext-fill.svg": [
		13856,
		13856
	],
	"./file-earmark-richtext.svg": [
		98318,
		98318
	],
	"./file-earmark-ruled-fill.svg": [
		64001,
		64001
	],
	"./file-earmark-ruled.svg": [
		28485,
		28485
	],
	"./file-earmark-slides-fill.svg": [
		23863,
		23863
	],
	"./file-earmark-slides.svg": [
		57339,
		57339
	],
	"./file-earmark-spreadsheet-fill.svg": [
		88413,
		88413
	],
	"./file-earmark-spreadsheet.svg": [
		75721,
		75721
	],
	"./file-earmark-text-fill.svg": [
		7386,
		7386
	],
	"./file-earmark-text.svg": [
		33552,
		33552
	],
	"./file-earmark-word-fill.svg": [
		58829,
		58829
	],
	"./file-earmark-word.svg": [
		16793,
		16793
	],
	"./file-earmark-x-fill.svg": [
		72107,
		72107
	],
	"./file-earmark-x.svg": [
		16087,
		16087
	],
	"./file-earmark-zip-fill.svg": [
		22868,
		22868
	],
	"./file-earmark-zip.svg": [
		22970,
		22970
	],
	"./file-earmark.svg": [
		83360,
		83360
	],
	"./file-easel-fill.svg": [
		48429,
		48429
	],
	"./file-easel.svg": [
		47033,
		47033
	],
	"./file-excel-fill.svg": [
		544,
		544
	],
	"./file-excel.svg": [
		51950,
		51950
	],
	"./file-fill.svg": [
		35498,
		35498
	],
	"./file-font-fill.svg": [
		86516,
		86516
	],
	"./file-font.svg": [
		16986,
		16986
	],
	"./file-image-fill.svg": [
		96542,
		96542
	],
	"./file-image.svg": [
		10700,
		10700
	],
	"./file-lock-fill.svg": [
		8618,
		8618
	],
	"./file-lock.svg": [
		6848,
		6848
	],
	"./file-lock2-fill.svg": [
		96476,
		96476
	],
	"./file-lock2.svg": [
		83410,
		83410
	],
	"./file-medical-fill.svg": [
		15668,
		15668
	],
	"./file-medical.svg": [
		19994,
		19994
	],
	"./file-minus-fill.svg": [
		87835,
		87835
	],
	"./file-minus.svg": [
		33895,
		33895
	],
	"./file-music-fill.svg": [
		81128,
		81128
	],
	"./file-music.svg": [
		65286,
		65286
	],
	"./file-pdf-fill.svg": [
		75561,
		75561
	],
	"./file-pdf.svg": [
		19485,
		19485
	],
	"./file-person-fill.svg": [
		44120,
		44120
	],
	"./file-person.svg": [
		77238,
		77238
	],
	"./file-play-fill.svg": [
		54787,
		54787
	],
	"./file-play.svg": [
		83935,
		83935
	],
	"./file-plus-fill.svg": [
		6845,
		6845
	],
	"./file-plus.svg": [
		8713,
		8713
	],
	"./file-post-fill.svg": [
		60575,
		60575
	],
	"./file-post.svg": [
		58163,
		58163
	],
	"./file-ppt-fill.svg": [
		1591,
		1591
	],
	"./file-ppt.svg": [
		16603,
		16603
	],
	"./file-richtext-fill.svg": [
		37504,
		37504
	],
	"./file-richtext.svg": [
		62542,
		62542
	],
	"./file-ruled-fill.svg": [
		16161,
		16161
	],
	"./file-ruled.svg": [
		69381,
		69381
	],
	"./file-slides-fill.svg": [
		7799,
		7799
	],
	"./file-slides.svg": [
		67963,
		67963
	],
	"./file-spreadsheet-fill.svg": [
		81533,
		81533
	],
	"./file-spreadsheet.svg": [
		7177,
		7177
	],
	"./file-text-fill.svg": [
		36570,
		36570
	],
	"./file-text.svg": [
		6480,
		6480
	],
	"./file-word-fill.svg": [
		76941,
		76941
	],
	"./file-word.svg": [
		62297,
		62297
	],
	"./file-x-fill.svg": [
		73099,
		73099
	],
	"./file-x.svg": [
		8215,
		8215
	],
	"./file-zip-fill.svg": [
		17652,
		17652
	],
	"./file-zip.svg": [
		83546,
		83546
	],
	"./file.svg": [
		74656,
		74656
	],
	"./files-alt.svg": [
		39933,
		39933
	],
	"./files.svg": [
		33891,
		33891
	],
	"./filetype-aac.svg": [
		84770,
		84770
	],
	"./filetype-ai.svg": [
		5603,
		5603
	],
	"./filetype-bmp.svg": [
		24646,
		24646
	],
	"./filetype-cs.svg": [
		74271,
		74271
	],
	"./filetype-css.svg": [
		22334,
		22334
	],
	"./filetype-csv.svg": [
		37987,
		37987
	],
	"./filetype-doc.svg": [
		82121,
		82121
	],
	"./filetype-docx.svg": [
		63587,
		63587
	],
	"./filetype-exe.svg": [
		48159,
		48159
	],
	"./filetype-gif.svg": [
		50973,
		50973
	],
	"./filetype-heic.svg": [
		37672,
		37672
	],
	"./filetype-html.svg": [
		26846,
		26846
	],
	"./filetype-java.svg": [
		62365,
		62365
	],
	"./filetype-jpg.svg": [
		18458,
		18458
	],
	"./filetype-js.svg": [
		65140,
		65140
	],
	"./filetype-json.svg": [
		8471,
		8471
	],
	"./filetype-jsx.svg": [
		55460,
		55460
	],
	"./filetype-key.svg": [
		15106,
		15106
	],
	"./filetype-m4p.svg": [
		95166,
		95166
	],
	"./filetype-md.svg": [
		6258,
		6258
	],
	"./filetype-mdx.svg": [
		78182,
		78182
	],
	"./filetype-mov.svg": [
		293,
		293
	],
	"./filetype-mp3.svg": [
		10705,
		10705
	],
	"./filetype-mp4.svg": [
		85358,
		85358
	],
	"./filetype-otf.svg": [
		22138,
		22138
	],
	"./filetype-pdf.svg": [
		16501,
		16501
	],
	"./filetype-php.svg": [
		99271,
		99271
	],
	"./filetype-png.svg": [
		6150,
		6150
	],
	"./filetype-ppt.svg": [
		30003,
		30003
	],
	"./filetype-pptx.svg": [
		21297,
		21297
	],
	"./filetype-psd.svg": [
		51462,
		51462
	],
	"./filetype-py.svg": [
		69484,
		47103
	],
	"./filetype-raw.svg": [
		63901,
		63901
	],
	"./filetype-rb.svg": [
		55997,
		55997
	],
	"./filetype-sass.svg": [
		26607,
		26607
	],
	"./filetype-scss.svg": [
		73345,
		73345
	],
	"./filetype-sh.svg": [
		39076,
		39076
	],
	"./filetype-sql.svg": [
		96211,
		96211
	],
	"./filetype-svg.svg": [
		99329,
		99329
	],
	"./filetype-tiff.svg": [
		66788,
		66788
	],
	"./filetype-tsx.svg": [
		59958,
		59958
	],
	"./filetype-ttf.svg": [
		58073,
		58073
	],
	"./filetype-txt.svg": [
		37415,
		37415
	],
	"./filetype-wav.svg": [
		83717,
		83717
	],
	"./filetype-woff.svg": [
		19927,
		19927
	],
	"./filetype-xls.svg": [
		61864,
		61864
	],
	"./filetype-xlsx.svg": [
		94608,
		94608
	],
	"./filetype-xml.svg": [
		73308,
		73308
	],
	"./filetype-yml.svg": [
		2001,
		2001
	],
	"./film.svg": [
		37656,
		37656
	],
	"./filter-circle-fill.svg": [
		90009,
		90009
	],
	"./filter-circle.svg": [
		87469,
		87469
	],
	"./filter-left.svg": [
		95802,
		95802
	],
	"./filter-right.svg": [
		84177,
		84177
	],
	"./filter-square-fill.svg": [
		28650,
		28650
	],
	"./filter-square.svg": [
		76320,
		76320
	],
	"./filter.svg": [
		38912,
		38912
	],
	"./fingerprint.svg": [
		42242,
		42242
	],
	"./fire.svg": [
		46966,
		46966
	],
	"./flag-fill.svg": [
		86690,
		86690
	],
	"./flag.svg": [
		73224,
		73224
	],
	"./flask-fill.svg": [
		9419,
		9419
	],
	"./flask-florence-fill.svg": [
		29934,
		29934
	],
	"./flask-florence.svg": [
		72252,
		72252
	],
	"./flask.svg": [
		51863,
		51863
	],
	"./floppy-fill.svg": [
		37802,
		37802
	],
	"./floppy.svg": [
		4000,
		4000
	],
	"./floppy2-fill.svg": [
		35612,
		35612
	],
	"./floppy2.svg": [
		62066,
		62066
	],
	"./flower1.svg": [
		27004,
		27004
	],
	"./flower2.svg": [
		6031,
		6031
	],
	"./flower3.svg": [
		27102,
		27102
	],
	"./folder-check.svg": [
		93921,
		93921
	],
	"./folder-fill.svg": [
		73980,
		73980
	],
	"./folder-minus.svg": [
		39481,
		39481
	],
	"./folder-plus.svg": [
		39755,
		39755
	],
	"./folder-symlink-fill.svg": [
		79178,
		79178
	],
	"./folder-symlink.svg": [
		60672,
		60672
	],
	"./folder-x.svg": [
		96697,
		96697
	],
	"./folder.svg": [
		37842,
		37842
	],
	"./folder2-open.svg": [
		8973,
		8973
	],
	"./folder2.svg": [
		56492,
		56492
	],
	"./fonts.svg": [
		82908,
		82908
	],
	"./fork-knife.svg": [
		69230,
		69230
	],
	"./forward-fill.svg": [
		85917,
		85917
	],
	"./forward.svg": [
		3593,
		3593
	],
	"./front.svg": [
		87419,
		87419
	],
	"./fuel-pump-diesel-fill.svg": [
		29378,
		29378
	],
	"./fuel-pump-diesel.svg": [
		58664,
		58664
	],
	"./fuel-pump-fill.svg": [
		98465,
		98465
	],
	"./fuel-pump.svg": [
		56133,
		56133
	],
	"./fullscreen-exit.svg": [
		31614,
		31614
	],
	"./fullscreen.svg": [
		5889,
		5889
	],
	"./funnel-fill.svg": [
		23156,
		23156
	],
	"./funnel.svg": [
		11866,
		11866
	],
	"./gear-fill.svg": [
		57383,
		57383
	],
	"./gear-wide-connected.svg": [
		63867,
		63867
	],
	"./gear-wide.svg": [
		3641,
		3641
	],
	"./gear.svg": [
		63307,
		63307
	],
	"./gem.svg": [
		42743,
		42743
	],
	"./gender-ambiguous.svg": [
		91654,
		91654
	],
	"./gender-female.svg": [
		81022,
		81022
	],
	"./gender-male.svg": [
		43433,
		43433
	],
	"./gender-neuter.svg": [
		41635,
		41635
	],
	"./gender-trans.svg": [
		74880,
		74880
	],
	"./geo-alt-fill.svg": [
		30707,
		30707
	],
	"./geo-alt.svg": [
		81391,
		81391
	],
	"./geo-fill.svg": [
		89697,
		89697
	],
	"./geo.svg": [
		85541,
		85541
	],
	"./gift-fill.svg": [
		12806,
		12806
	],
	"./gift.svg": [
		44996,
		44996
	],
	"./git.svg": [
		56842,
		56842
	],
	"./github.svg": [
		76543,
		76543
	],
	"./gitlab.svg": [
		4991,
		4991
	],
	"./globe-americas-fill.svg": [
		10285,
		10285
	],
	"./globe-americas.svg": [
		96025,
		96025
	],
	"./globe-asia-australia-fill.svg": [
		49877,
		49877
	],
	"./globe-asia-australia.svg": [
		37425,
		37425
	],
	"./globe-central-south-asia-fill.svg": [
		86962,
		86962
	],
	"./globe-central-south-asia.svg": [
		71256,
		71256
	],
	"./globe-europe-africa-fill.svg": [
		57319,
		57319
	],
	"./globe-europe-africa.svg": [
		72363,
		72363
	],
	"./globe.svg": [
		61097,
		61097
	],
	"./globe2.svg": [
		62489,
		62489
	],
	"./google-play.svg": [
		91518,
		91518
	],
	"./google.svg": [
		21799,
		21799
	],
	"./gpu-card.svg": [
		25879,
		25879
	],
	"./graph-down-arrow.svg": [
		24231,
		24231
	],
	"./graph-down.svg": [
		52643,
		52643
	],
	"./graph-up-arrow.svg": [
		33656,
		33656
	],
	"./graph-up.svg": [
		13660,
		13660
	],
	"./grid-1x2-fill.svg": [
		98751,
		21132
	],
	"./grid-1x2.svg": [
		24130,
		24130
	],
	"./grid-3x2-gap-fill.svg": [
		84607,
		84607
	],
	"./grid-3x2-gap.svg": [
		55091,
		55091
	],
	"./grid-3x2.svg": [
		88912,
		88912
	],
	"./grid-3x3-gap-fill.svg": [
		94908,
		94908
	],
	"./grid-3x3-gap.svg": [
		73874,
		73874
	],
	"./grid-3x3.svg": [
		24449,
		24449
	],
	"./grid-fill.svg": [
		65332,
		65332
	],
	"./grid.svg": [
		51962,
		51962
	],
	"./grip-horizontal.svg": [
		88755,
		88755
	],
	"./grip-vertical.svg": [
		8329,
		8329
	],
	"./h-circle-fill.svg": [
		19567,
		19567
	],
	"./h-circle.svg": [
		82947,
		82947
	],
	"./h-square-fill.svg": [
		20972,
		20972
	],
	"./h-square.svg": [
		25826,
		25826
	],
	"./hammer.svg": [
		80984,
		80984
	],
	"./hand-index-fill.svg": [
		2700,
		2700
	],
	"./hand-index-thumb-fill.svg": [
		1353,
		1353
	],
	"./hand-index-thumb.svg": [
		47837,
		47837
	],
	"./hand-index.svg": [
		78466,
		78466
	],
	"./hand-thumbs-down-fill.svg": [
		12352,
		12352
	],
	"./hand-thumbs-down.svg": [
		86830,
		86830
	],
	"./hand-thumbs-up-fill.svg": [
		89025,
		89025
	],
	"./hand-thumbs-up.svg": [
		62629,
		62629
	],
	"./handbag-fill.svg": [
		79917,
		79917
	],
	"./handbag.svg": [
		86745,
		86745
	],
	"./hash.svg": [
		86502,
		86502
	],
	"./hdd-fill.svg": [
		49544,
		49544
	],
	"./hdd-network-fill.svg": [
		85891,
		85891
	],
	"./hdd-network.svg": [
		69727,
		69727
	],
	"./hdd-rack-fill.svg": [
		4992,
		4992
	],
	"./hdd-rack.svg": [
		98094,
		98094
	],
	"./hdd-stack-fill.svg": [
		75705,
		75705
	],
	"./hdd-stack.svg": [
		82829,
		82829
	],
	"./hdd.svg": [
		69574,
		69574
	],
	"./hdmi-fill.svg": [
		88102,
		88102
	],
	"./hdmi.svg": [
		25444,
		3063
	],
	"./headphones.svg": [
		18151,
		18151
	],
	"./headset-vr.svg": [
		30737,
		30737
	],
	"./headset.svg": [
		90752,
		90752
	],
	"./heart-arrow.svg": [
		27210,
		27210
	],
	"./heart-fill.svg": [
		30656,
		30656
	],
	"./heart-half.svg": [
		70188,
		70188
	],
	"./heart-pulse-fill.svg": [
		68652,
		68652
	],
	"./heart-pulse.svg": [
		32578,
		32578
	],
	"./heart.svg": [
		65646,
		65646
	],
	"./heartbreak-fill.svg": [
		26591,
		26591
	],
	"./heartbreak.svg": [
		97043,
		97043
	],
	"./hearts.svg": [
		76785,
		76785
	],
	"./heptagon-fill.svg": [
		18946,
		18946
	],
	"./heptagon-half.svg": [
		71902,
		71902
	],
	"./heptagon.svg": [
		86728,
		86728
	],
	"./hexagon-fill.svg": [
		91664,
		91664
	],
	"./hexagon-half.svg": [
		54908,
		54908
	],
	"./hexagon.svg": [
		45214,
		45214
	],
	"./highlighter.svg": [
		89223,
		89223
	],
	"./highlights.svg": [
		48649,
		48649
	],
	"./hospital-fill.svg": [
		39526,
		39526
	],
	"./hospital.svg": [
		99972,
		99972
	],
	"./hourglass-bottom.svg": [
		89872,
		89872
	],
	"./hourglass-split.svg": [
		57479,
		57479
	],
	"./hourglass-top.svg": [
		52362,
		52362
	],
	"./hourglass.svg": [
		43608,
		43608
	],
	"./house-add-fill.svg": [
		99186,
		99186
	],
	"./house-add.svg": [
		50936,
		50936
	],
	"./house-check-fill.svg": [
		15557,
		15557
	],
	"./house-check.svg": [
		28321,
		28321
	],
	"./house-dash-fill.svg": [
		10719,
		10719
	],
	"./house-dash.svg": [
		66931,
		66931
	],
	"./house-door-fill.svg": [
		74171,
		74171
	],
	"./house-door.svg": [
		93671,
		93671
	],
	"./house-down-fill.svg": [
		94599,
		94599
	],
	"./house-down.svg": [
		47467,
		47467
	],
	"./house-exclamation-fill.svg": [
		14376,
		14376
	],
	"./house-exclamation.svg": [
		32774,
		32774
	],
	"./house-fill.svg": [
		14908,
		14908
	],
	"./house-gear-fill.svg": [
		58056,
		58056
	],
	"./house-gear.svg": [
		10566,
		10566
	],
	"./house-heart-fill.svg": [
		63649,
		63649
	],
	"./house-heart.svg": [
		12389,
		12389
	],
	"./house-lock-fill.svg": [
		46244,
		46244
	],
	"./house-lock.svg": [
		16778,
		16778
	],
	"./house-slash-fill.svg": [
		26860,
		26860
	],
	"./house-slash.svg": [
		97186,
		97186
	],
	"./house-up-fill.svg": [
		25414,
		25414
	],
	"./house-up.svg": [
		4868,
		4868
	],
	"./house-x-fill.svg": [
		7981,
		7981
	],
	"./house-x.svg": [
		24185,
		24185
	],
	"./house.svg": [
		80722,
		80722
	],
	"./houses-fill.svg": [
		49753,
		49753
	],
	"./houses.svg": [
		77837,
		77837
	],
	"./hr.svg": [
		5704,
		5704
	],
	"./hurricane.svg": [
		66187,
		66187
	],
	"./hypnotize.svg": [
		96090,
		96090
	],
	"./image-alt.svg": [
		49227,
		49227
	],
	"./image-fill.svg": [
		52061,
		52061
	],
	"./image.svg": [
		89065,
		89065
	],
	"./images.svg": [
		26056,
		26056
	],
	"./inbox-fill.svg": [
		79500,
		79500
	],
	"./inbox.svg": [
		45378,
		45378
	],
	"./inboxes-fill.svg": [
		60020,
		60020
	],
	"./inboxes.svg": [
		65722,
		65722
	],
	"./incognito.svg": [
		7820,
		7820
	],
	"./indent.svg": [
		99828,
		99828
	],
	"./infinity.svg": [
		12610,
		12610
	],
	"./info-circle-fill.svg": [
		18243,
		18243
	],
	"./info-circle.svg": [
		15103,
		15103
	],
	"./info-lg.svg": [
		27568,
		27568
	],
	"./info-square-fill.svg": [
		48480,
		48480
	],
	"./info-square.svg": [
		74510,
		74510
	],
	"./info.svg": [
		75346,
		75346
	],
	"./input-cursor-text.svg": [
		33151,
		33151
	],
	"./input-cursor.svg": [
		94445,
		94445
	],
	"./instagram.svg": [
		85762,
		85762
	],
	"./intersect.svg": [
		35533,
		35533
	],
	"./javascript.svg": [
		15239,
		15239
	],
	"./journal-album.svg": [
		94337,
		94337
	],
	"./journal-arrow-down.svg": [
		83316,
		83316
	],
	"./journal-arrow-up.svg": [
		96463,
		96463
	],
	"./journal-bookmark-fill.svg": [
		6782,
		6782
	],
	"./journal-bookmark.svg": [
		92460,
		92460
	],
	"./journal-check.svg": [
		35132,
		35132
	],
	"./journal-code.svg": [
		81192,
		81192
	],
	"./journal-medical.svg": [
		66769,
		66769
	],
	"./journal-minus.svg": [
		95932,
		95932
	],
	"./journal-plus.svg": [
		25300,
		25300
	],
	"./journal-richtext.svg": [
		23515,
		23515
	],
	"./journal-text.svg": [
		45633,
		45633
	],
	"./journal-x.svg": [
		5860,
		5860
	],
	"./journal.svg": [
		62411,
		62411
	],
	"./journals.svg": [
		16322,
		16322
	],
	"./joystick.svg": [
		9480,
		9480
	],
	"./justify-left.svg": [
		61276,
		61276
	],
	"./justify-right.svg": [
		45123,
		45123
	],
	"./justify.svg": [
		91202,
		91202
	],
	"./kanban-fill.svg": [
		96515,
		96515
	],
	"./kanban.svg": [
		94879,
		94879
	],
	"./key-fill.svg": [
		3083,
		3083
	],
	"./key.svg": [
		75703,
		75703
	],
	"./keyboard-fill.svg": [
		64773,
		64773
	],
	"./keyboard.svg": [
		70401,
		70401
	],
	"./ladder.svg": [
		16426,
		16426
	],
	"./lamp-fill.svg": [
		96698,
		96698
	],
	"./lamp.svg": [
		25200,
		25200
	],
	"./laptop-fill.svg": [
		95756,
		95756
	],
	"./laptop.svg": [
		49698,
		49698
	],
	"./layer-backward.svg": [
		48685,
		48685
	],
	"./layer-forward.svg": [
		51805,
		51805
	],
	"./layers-fill.svg": [
		92373,
		92373
	],
	"./layers-half.svg": [
		89950,
		89950
	],
	"./layers.svg": [
		4648,
		4648
	],
	"./layout-sidebar-inset-reverse.svg": [
		53950,
		53950
	],
	"./layout-sidebar-inset.svg": [
		31147,
		31147
	],
	"./layout-sidebar-reverse.svg": [
		45782,
		45782
	],
	"./layout-sidebar.svg": [
		38963,
		38963
	],
	"./layout-split.svg": [
		25727,
		25727
	],
	"./layout-text-sidebar-reverse.svg": [
		51910,
		51910
	],
	"./layout-text-sidebar.svg": [
		16835,
		16835
	],
	"./layout-text-window-reverse.svg": [
		47920,
		47920
	],
	"./layout-text-window.svg": [
		57221,
		57221
	],
	"./layout-three-columns.svg": [
		48913,
		48913
	],
	"./layout-wtf.svg": [
		4778,
		4778
	],
	"./leaf-fill.svg": [
		39520,
		39520
	],
	"./leaf.svg": [
		32718,
		32718
	],
	"./life-preserver.svg": [
		68117,
		68117
	],
	"./lightbulb-fill.svg": [
		91423,
		91423
	],
	"./lightbulb-off-fill.svg": [
		57316,
		57316
	],
	"./lightbulb-off.svg": [
		6811,
		6811
	],
	"./lightbulb.svg": [
		1523,
		1523
	],
	"./lightning-charge-fill.svg": [
		11205,
		11205
	],
	"./lightning-charge.svg": [
		73025,
		73025
	],
	"./lightning-fill.svg": [
		74622,
		74622
	],
	"./lightning.svg": [
		63372,
		63372
	],
	"./line.svg": [
		52364,
		52364
	],
	"./link-45deg.svg": [
		23385,
		45766
	],
	"./link.svg": [
		62074,
		62074
	],
	"./linkedin.svg": [
		6084,
		6084
	],
	"./list-check.svg": [
		68877,
		68877
	],
	"./list-columns-reverse.svg": [
		3613,
		3613
	],
	"./list-columns.svg": [
		43188,
		43188
	],
	"./list-nested.svg": [
		36414,
		36414
	],
	"./list-ol.svg": [
		70074,
		70074
	],
	"./list-stars.svg": [
		22522,
		22522
	],
	"./list-task.svg": [
		71876,
		71876
	],
	"./list-ul.svg": [
		2604,
		2604
	],
	"./list.svg": [
		25422,
		25422
	],
	"./lock-fill.svg": [
		74119,
		74119
	],
	"./lock.svg": [
		92427,
		92427
	],
	"./luggage-fill.svg": [
		32300,
		32300
	],
	"./luggage.svg": [
		94434,
		94434
	],
	"./lungs-fill.svg": [
		6785,
		6785
	],
	"./lungs.svg": [
		60005,
		60005
	],
	"./magic.svg": [
		2223,
		2223
	],
	"./magnet-fill.svg": [
		62434,
		62434
	],
	"./magnet.svg": [
		83176,
		83176
	],
	"./mailbox-flag.svg": [
		29005,
		29005
	],
	"./mailbox.svg": [
		40190,
		40190
	],
	"./mailbox2-flag.svg": [
		27539,
		27539
	],
	"./mailbox2.svg": [
		82672,
		82672
	],
	"./map-fill.svg": [
		92202,
		92202
	],
	"./map.svg": [
		22976,
		22976
	],
	"./markdown-fill.svg": [
		32485,
		32485
	],
	"./markdown.svg": [
		71067,
		71067
	],
	"./marker-tip.svg": [
		87388,
		87388
	],
	"./mask.svg": [
		73810,
		73810
	],
	"./mastodon.svg": [
		73095,
		73095
	],
	"./measuring-cup-fill.svg": [
		70334,
		70334
	],
	"./measuring-cup.svg": [
		3852,
		3852
	],
	"./medium.svg": [
		96199,
		96199
	],
	"./megaphone-fill.svg": [
		49294,
		49294
	],
	"./megaphone.svg": [
		32604,
		32604
	],
	"./memory.svg": [
		94875,
		94875
	],
	"./menu-app-fill.svg": [
		84121,
		84121
	],
	"./menu-app.svg": [
		59661,
		59661
	],
	"./menu-button-fill.svg": [
		39346,
		39346
	],
	"./menu-button-wide-fill.svg": [
		79994,
		79994
	],
	"./menu-button-wide.svg": [
		42832,
		42832
	],
	"./menu-button.svg": [
		34040,
		34040
	],
	"./menu-down.svg": [
		13256,
		13256
	],
	"./menu-up.svg": [
		28539,
		28539
	],
	"./messenger.svg": [
		22839,
		22839
	],
	"./meta.svg": [
		41881,
		41881
	],
	"./mic-fill.svg": [
		95751,
		95751
	],
	"./mic-mute-fill.svg": [
		77083,
		77083
	],
	"./mic-mute.svg": [
		85703,
		85703
	],
	"./mic.svg": [
		56811,
		56811
	],
	"./microsoft-teams.svg": [
		12707,
		12707
	],
	"./microsoft.svg": [
		64210,
		64210
	],
	"./minecart-loaded.svg": [
		83045,
		83045
	],
	"./minecart.svg": [
		89741,
		89741
	],
	"./modem-fill.svg": [
		7242,
		7242
	],
	"./modem.svg": [
		71840,
		71840
	],
	"./moisture.svg": [
		91428,
		91428
	],
	"./moon-fill.svg": [
		52309,
		52309
	],
	"./moon-stars-fill.svg": [
		60357,
		60357
	],
	"./moon-stars.svg": [
		22817,
		22817
	],
	"./moon.svg": [
		49681,
		49681
	],
	"./mortarboard-fill.svg": [
		46899,
		46899
	],
	"./mortarboard.svg": [
		89135,
		89135
	],
	"./motherboard-fill.svg": [
		33977,
		33977
	],
	"./motherboard.svg": [
		93805,
		93805
	],
	"./mouse-fill.svg": [
		92363,
		92363
	],
	"./mouse.svg": [
		91959,
		91959
	],
	"./mouse2-fill.svg": [
		82923,
		82923
	],
	"./mouse2.svg": [
		91863,
		91863
	],
	"./mouse3-fill.svg": [
		6024,
		6024
	],
	"./mouse3.svg": [
		20678,
		20678
	],
	"./music-note-beamed.svg": [
		35671,
		35671
	],
	"./music-note-list.svg": [
		77465,
		77465
	],
	"./music-note.svg": [
		89292,
		89292
	],
	"./music-player-fill.svg": [
		29347,
		29347
	],
	"./music-player.svg": [
		72191,
		72191
	],
	"./newspaper.svg": [
		14199,
		14199
	],
	"./nintendo-switch.svg": [
		96526,
		96526
	],
	"./node-minus-fill.svg": [
		24961,
		24961
	],
	"./node-minus.svg": [
		57285,
		57285
	],
	"./node-plus-fill.svg": [
		37147,
		37147
	],
	"./node-plus.svg": [
		51431,
		51431
	],
	"./noise-reduction.svg": [
		25992,
		25992
	],
	"./nut-fill.svg": [
		74623,
		74623
	],
	"./nut.svg": [
		34579,
		34579
	],
	"./nvidia.svg": [
		94699,
		94699
	],
	"./nvme-fill.svg": [
		32682,
		32682
	],
	"./nvme.svg": [
		77088,
		77088
	],
	"./octagon-fill.svg": [
		4935,
		4935
	],
	"./octagon-half.svg": [
		46759,
		46759
	],
	"./octagon.svg": [
		93483,
		93483
	],
	"./openai.svg": [
		3063,
		25444
	],
	"./opencollective.svg": [
		40666,
		40666
	],
	"./optical-audio-fill.svg": [
		79307,
		79307
	],
	"./optical-audio.svg": [
		3895,
		3895
	],
	"./option.svg": [
		44457,
		44457
	],
	"./outlet.svg": [
		56145,
		56145
	],
	"./p-circle-fill.svg": [
		77559,
		77559
	],
	"./p-circle.svg": [
		41275,
		41275
	],
	"./p-square-fill.svg": [
		25108,
		25108
	],
	"./p-square.svg": [
		15354,
		15354
	],
	"./paint-bucket.svg": [
		88549,
		88549
	],
	"./palette-fill.svg": [
		54807,
		54807
	],
	"./palette.svg": [
		57019,
		57019
	],
	"./palette2.svg": [
		57507,
		57507
	],
	"./paperclip.svg": [
		11274,
		11274
	],
	"./paragraph.svg": [
		94100,
		94100
	],
	"./pass-fill.svg": [
		8225,
		8225
	],
	"./pass.svg": [
		11461,
		11461
	],
	"./passport-fill.svg": [
		72058,
		72058
	],
	"./passport.svg": [
		5776,
		5776
	],
	"./patch-check-fill.svg": [
		46691,
		46691
	],
	"./patch-check.svg": [
		51871,
		51871
	],
	"./patch-exclamation-fill.svg": [
		30398,
		30398
	],
	"./patch-exclamation.svg": [
		15532,
		15532
	],
	"./patch-minus-fill.svg": [
		99919,
		99919
	],
	"./patch-minus.svg": [
		98659,
		98659
	],
	"./patch-plus-fill.svg": [
		32609,
		32609
	],
	"./patch-plus.svg": [
		99493,
		99493
	],
	"./patch-question-fill.svg": [
		18913,
		18913
	],
	"./patch-question.svg": [
		23557,
		23557
	],
	"./pause-btn-fill.svg": [
		95195,
		95195
	],
	"./pause-btn.svg": [
		78279,
		78279
	],
	"./pause-circle-fill.svg": [
		92745,
		92745
	],
	"./pause-circle.svg": [
		31389,
		31389
	],
	"./pause-fill.svg": [
		58554,
		58554
	],
	"./pause.svg": [
		48304,
		48304
	],
	"./paypal.svg": [
		97047,
		97047
	],
	"./pc-display-horizontal.svg": [
		38565,
		38565
	],
	"./pc-display.svg": [
		92563,
		92563
	],
	"./pc-horizontal.svg": [
		18482,
		18482
	],
	"./pc.svg": [
		45553,
		45553
	],
	"./pci-card-network.svg": [
		81216,
		81216
	],
	"./pci-card-sound.svg": [
		37091,
		37091
	],
	"./pci-card.svg": [
		13081,
		13081
	],
	"./peace-fill.svg": [
		9218,
		9218
	],
	"./peace.svg": [
		58280,
		58280
	],
	"./pen-fill.svg": [
		93991,
		93991
	],
	"./pen.svg": [
		33035,
		33035
	],
	"./pencil-fill.svg": [
		4373,
		4373
	],
	"./pencil-square.svg": [
		57251,
		57251
	],
	"./pencil.svg": [
		593,
		593
	],
	"./pentagon-fill.svg": [
		61808,
		61808
	],
	"./pentagon-half.svg": [
		25052,
		25052
	],
	"./pentagon.svg": [
		94270,
		71889
	],
	"./people-fill.svg": [
		72243,
		72243
	],
	"./people.svg": [
		66351,
		66351
	],
	"./percent.svg": [
		90093,
		90093
	],
	"./perplexity.svg": [
		89456,
		89456
	],
	"./person-add.svg": [
		28739,
		28739
	],
	"./person-arms-up.svg": [
		68943,
		68943
	],
	"./person-badge-fill.svg": [
		19903,
		19903
	],
	"./person-badge.svg": [
		17651,
		17651
	],
	"./person-bounding-box.svg": [
		20546,
		20546
	],
	"./person-check-fill.svg": [
		21568,
		21568
	],
	"./person-check.svg": [
		91342,
		91342
	],
	"./person-circle.svg": [
		710,
		710
	],
	"./person-dash-fill.svg": [
		11248,
		11248
	],
	"./person-dash.svg": [
		82302,
		82302
	],
	"./person-down.svg": [
		71238,
		71238
	],
	"./person-exclamation.svg": [
		48761,
		48761
	],
	"./person-fill-add.svg": [
		74703,
		74703
	],
	"./person-fill-check.svg": [
		3970,
		3970
	],
	"./person-fill-dash.svg": [
		39674,
		39674
	],
	"./person-fill-down.svg": [
		37386,
		37386
	],
	"./person-fill-exclamation.svg": [
		19909,
		19909
	],
	"./person-fill-gear.svg": [
		72267,
		72267
	],
	"./person-fill-lock.svg": [
		32811,
		32811
	],
	"./person-fill-slash.svg": [
		60873,
		60873
	],
	"./person-fill-up.svg": [
		31833,
		31833
	],
	"./person-fill-x.svg": [
		246,
		246
	],
	"./person-fill.svg": [
		18557,
		18557
	],
	"./person-gear.svg": [
		94311,
		94311
	],
	"./person-heart.svg": [
		94994,
		94994
	],
	"./person-hearts.svg": [
		98605,
		98605
	],
	"./person-lines-fill.svg": [
		41711,
		41711
	],
	"./person-lock.svg": [
		8023,
		8023
	],
	"./person-plus-fill.svg": [
		7980,
		7980
	],
	"./person-plus.svg": [
		16962,
		16962
	],
	"./person-raised-hand.svg": [
		26700,
		26700
	],
	"./person-rolodex.svg": [
		30271,
		30271
	],
	"./person-slash.svg": [
		82005,
		82005
	],
	"./person-square.svg": [
		55899,
		55899
	],
	"./person-standing-dress.svg": [
		28976,
		28976
	],
	"./person-standing.svg": [
		80934,
		80934
	],
	"./person-up.svg": [
		30653,
		30653
	],
	"./person-vcard-fill.svg": [
		95184,
		95184
	],
	"./person-vcard.svg": [
		56990,
		56990
	],
	"./person-video.svg": [
		26323,
		26323
	],
	"./person-video2.svg": [
		17259,
		17259
	],
	"./person-video3.svg": [
		11994,
		11994
	],
	"./person-walking.svg": [
		71015,
		71015
	],
	"./person-wheelchair.svg": [
		23986,
		23986
	],
	"./person-workspace.svg": [
		18129,
		18129
	],
	"./person-x-fill.svg": [
		47060,
		47060
	],
	"./person-x.svg": [
		82138,
		82138
	],
	"./person.svg": [
		86185,
		86185
	],
	"./phone-fill.svg": [
		41980,
		41980
	],
	"./phone-flip.svg": [
		88030,
		88030
	],
	"./phone-landscape-fill.svg": [
		98892,
		98892
	],
	"./phone-landscape.svg": [
		38690,
		38690
	],
	"./phone-vibrate-fill.svg": [
		45690,
		45690
	],
	"./phone-vibrate.svg": [
		52912,
		52912
	],
	"./phone.svg": [
		98322,
		98322
	],
	"./pie-chart-fill.svg": [
		77339,
		77339
	],
	"./pie-chart.svg": [
		96103,
		96103
	],
	"./piggy-bank-fill.svg": [
		1209,
		1209
	],
	"./piggy-bank.svg": [
		3949,
		3949
	],
	"./pin-angle-fill.svg": [
		28469,
		28469
	],
	"./pin-angle.svg": [
		26193,
		26193
	],
	"./pin-fill.svg": [
		57275,
		57275
	],
	"./pin-map-fill.svg": [
		636,
		636
	],
	"./pin-map.svg": [
		70738,
		70738
	],
	"./pin.svg": [
		15847,
		15847
	],
	"./pinterest.svg": [
		83416,
		83416
	],
	"./pip-fill.svg": [
		81205,
		3586
	],
	"./pip.svg": [
		56529,
		56529
	],
	"./play-btn-fill.svg": [
		5299,
		5299
	],
	"./play-btn.svg": [
		64175,
		64175
	],
	"./play-circle-fill.svg": [
		83585,
		83585
	],
	"./play-circle.svg": [
		20261,
		20261
	],
	"./play-fill.svg": [
		73106,
		73106
	],
	"./play.svg": [
		15800,
		15800
	],
	"./playstation.svg": [
		98692,
		98692
	],
	"./plug-fill.svg": [
		24212,
		24212
	],
	"./plug.svg": [
		59002,
		59002
	],
	"./plugin.svg": [
		93371,
		93371
	],
	"./plus-circle-dotted.svg": [
		41148,
		41148
	],
	"./plus-circle-fill.svg": [
		65055,
		65055
	],
	"./plus-circle.svg": [
		44467,
		44467
	],
	"./plus-lg.svg": [
		99316,
		99316
	],
	"./plus-slash-minus.svg": [
		40077,
		40077
	],
	"./plus-square-dotted.svg": [
		33187,
		33187
	],
	"./plus-square-fill.svg": [
		68796,
		68796
	],
	"./plus-square.svg": [
		97970,
		97970
	],
	"./plus.svg": [
		24054,
		24054
	],
	"./postage-fill.svg": [
		21122,
		21122
	],
	"./postage-heart-fill.svg": [
		19732,
		19732
	],
	"./postage-heart.svg": [
		36378,
		36378
	],
	"./postage.svg": [
		33617,
		33617
	],
	"./postcard-fill.svg": [
		82092,
		82092
	],
	"./postcard-heart-fill.svg": [
		24977,
		24977
	],
	"./postcard-heart.svg": [
		79637,
		79637
	],
	"./postcard.svg": [
		71138,
		71138
	],
	"./power.svg": [
		39269,
		39269
	],
	"./prescription.svg": [
		82522,
		82522
	],
	"./prescription2.svg": [
		26532,
		26532
	],
	"./printer-fill.svg": [
		84312,
		84312
	],
	"./printer.svg": [
		95062,
		95062
	],
	"./projector-fill.svg": [
		65252,
		65252
	],
	"./projector.svg": [
		20170,
		20170
	],
	"./puzzle-fill.svg": [
		29512,
		29512
	],
	"./puzzle.svg": [
		69606,
		69606
	],
	"./qr-code-scan.svg": [
		92131,
		92131
	],
	"./qr-code.svg": [
		83319,
		83319
	],
	"./question-circle-fill.svg": [
		38691,
		38691
	],
	"./question-circle.svg": [
		73343,
		73343
	],
	"./question-diamond-fill.svg": [
		43093,
		43093
	],
	"./question-diamond.svg": [
		25297,
		25297
	],
	"./question-lg.svg": [
		67056,
		67056
	],
	"./question-octagon-fill.svg": [
		10822,
		10822
	],
	"./question-octagon.svg": [
		41143,
		63524
	],
	"./question-square-fill.svg": [
		84032,
		84032
	],
	"./question-square.svg": [
		3598,
		3598
	],
	"./question.svg": [
		92594,
		92594
	],
	"./quora.svg": [
		60820,
		60820
	],
	"./quote.svg": [
		95398,
		95398
	],
	"./r-circle-fill.svg": [
		78109,
		78109
	],
	"./r-circle.svg": [
		66057,
		66057
	],
	"./r-square-fill.svg": [
		47358,
		47358
	],
	"./r-square.svg": [
		6220,
		6220
	],
	"./radar.svg": [
		30282,
		30282
	],
	"./radioactive.svg": [
		64181,
		64181
	],
	"./rainbow.svg": [
		72856,
		72856
	],
	"./receipt-cutoff.svg": [
		26956,
		26956
	],
	"./receipt.svg": [
		71482,
		71482
	],
	"./reception-0.svg": [
		87286,
		87286
	],
	"./reception-1.svg": [
		50503,
		50503
	],
	"./reception-2.svg": [
		85940,
		85940
	],
	"./reception-3.svg": [
		23925,
		23925
	],
	"./reception-4.svg": [
		94826,
		94826
	],
	"./record-btn-fill.svg": [
		91860,
		91860
	],
	"./record-btn.svg": [
		86202,
		86202
	],
	"./record-circle-fill.svg": [
		96272,
		96272
	],
	"./record-circle.svg": [
		59230,
		59230
	],
	"./record-fill.svg": [
		51493,
		51493
	],
	"./record.svg": [
		79073,
		79073
	],
	"./record2-fill.svg": [
		40869,
		40869
	],
	"./record2.svg": [
		99009,
		99009
	],
	"./recycle.svg": [
		30353,
		30353
	],
	"./reddit.svg": [
		56658,
		34277
	],
	"./regex.svg": [
		21947,
		21947
	],
	"./repeat-1.svg": [
		43765,
		43765
	],
	"./repeat.svg": [
		61027,
		61027
	],
	"./reply-all-fill.svg": [
		50582,
		50582
	],
	"./reply-all.svg": [
		47540,
		47540
	],
	"./reply-fill.svg": [
		79160,
		79160
	],
	"./reply.svg": [
		58934,
		58934
	],
	"./rewind-btn-fill.svg": [
		66626,
		66626
	],
	"./rewind-btn.svg": [
		90472,
		90472
	],
	"./rewind-circle-fill.svg": [
		99206,
		99206
	],
	"./rewind-circle.svg": [
		56516,
		56516
	],
	"./rewind-fill.svg": [
		76635,
		76635
	],
	"./rewind.svg": [
		46791,
		46791
	],
	"./robot.svg": [
		55814,
		55814
	],
	"./rocket-fill.svg": [
		33684,
		33684
	],
	"./rocket-takeoff-fill.svg": [
		10465,
		10465
	],
	"./rocket-takeoff.svg": [
		75301,
		75301
	],
	"./rocket.svg": [
		88538,
		88538
	],
	"./router-fill.svg": [
		57889,
		57889
	],
	"./router.svg": [
		1029,
		1029
	],
	"./rss-fill.svg": [
		89928,
		89928
	],
	"./rss.svg": [
		78310,
		78310
	],
	"./rulers.svg": [
		95405,
		95405
	],
	"./safe-fill.svg": [
		91125,
		91125
	],
	"./safe.svg": [
		72049,
		72049
	],
	"./safe2-fill.svg": [
		98325,
		98325
	],
	"./safe2.svg": [
		15793,
		15793
	],
	"./save-fill.svg": [
		94597,
		94597
	],
	"./save.svg": [
		81537,
		81537
	],
	"./save2-fill.svg": [
		37605,
		37605
	],
	"./save2.svg": [
		98721,
		98721
	],
	"./scissors.svg": [
		24119,
		24119
	],
	"./scooter.svg": [
		54711,
		54711
	],
	"./screwdriver.svg": [
		84680,
		84680
	],
	"./sd-card-fill.svg": [
		98120,
		98120
	],
	"./sd-card.svg": [
		16838,
		16838
	],
	"./search-heart-fill.svg": [
		37937,
		37937
	],
	"./search-heart.svg": [
		96661,
		96661
	],
	"./search.svg": [
		97685,
		97685
	],
	"./segmented-nav.svg": [
		79818,
		79818
	],
	"./send-arrow-down-fill.svg": [
		68237,
		68237
	],
	"./send-arrow-down.svg": [
		39769,
		39769
	],
	"./send-arrow-up-fill.svg": [
		19608,
		19608
	],
	"./send-arrow-up.svg": [
		78550,
		78550
	],
	"./send-check-fill.svg": [
		22531,
		22531
	],
	"./send-check.svg": [
		86271,
		86271
	],
	"./send-dash-fill.svg": [
		83097,
		83097
	],
	"./send-dash.svg": [
		17901,
		17901
	],
	"./send-exclamation-fill.svg": [
		13310,
		13310
	],
	"./send-exclamation.svg": [
		40940,
		40940
	],
	"./send-fill.svg": [
		1902,
		1902
	],
	"./send-plus-fill.svg": [
		34881,
		34881
	],
	"./send-plus.svg": [
		261,
		261
	],
	"./send-slash-fill.svg": [
		2934,
		2934
	],
	"./send-slash.svg": [
		3924,
		3924
	],
	"./send-x-fill.svg": [
		85687,
		85687
	],
	"./send-x.svg": [
		44283,
		44283
	],
	"./send.svg": [
		46780,
		46780
	],
	"./server.svg": [
		81211,
		81211
	],
	"./shadows.svg": [
		6205,
		6205
	],
	"./share-fill.svg": [
		14779,
		14779
	],
	"./share.svg": [
		25031,
		25031
	],
	"./shield-check.svg": [
		67598,
		67598
	],
	"./shield-exclamation.svg": [
		93401,
		93401
	],
	"./shield-fill-check.svg": [
		45154,
		45154
	],
	"./shield-fill-exclamation.svg": [
		57829,
		57829
	],
	"./shield-fill-minus.svg": [
		68574,
		46193
	],
	"./shield-fill-plus.svg": [
		78806,
		78806
	],
	"./shield-fill-x.svg": [
		27382,
		27382
	],
	"./shield-fill.svg": [
		8605,
		8605
	],
	"./shield-lock-fill.svg": [
		57899,
		57899
	],
	"./shield-lock.svg": [
		9367,
		9367
	],
	"./shield-minus.svg": [
		93066,
		93066
	],
	"./shield-plus.svg": [
		56834,
		56834
	],
	"./shield-shaded.svg": [
		33335,
		33335
	],
	"./shield-slash-fill.svg": [
		73809,
		73809
	],
	"./shield-slash.svg": [
		49954,
		49954
	],
	"./shield-x.svg": [
		52282,
		52282
	],
	"./shield.svg": [
		79177,
		79177
	],
	"./shift-fill.svg": [
		22172,
		22172
	],
	"./shift.svg": [
		53522,
		53522
	],
	"./shop-window.svg": [
		21335,
		21335
	],
	"./shop.svg": [
		52966,
		52966
	],
	"./shuffle.svg": [
		8653,
		8653
	],
	"./sign-dead-end-fill.svg": [
		52518,
		52518
	],
	"./sign-dead-end.svg": [
		99620,
		99620
	],
	"./sign-do-not-enter-fill.svg": [
		1054,
		1054
	],
	"./sign-do-not-enter.svg": [
		38188,
		38188
	],
	"./sign-intersection-fill.svg": [
		76993,
		76993
	],
	"./sign-intersection-side-fill.svg": [
		2859,
		2859
	],
	"./sign-intersection-side.svg": [
		51991,
		51991
	],
	"./sign-intersection-t-fill.svg": [
		54308,
		54308
	],
	"./sign-intersection-t.svg": [
		47050,
		47050
	],
	"./sign-intersection-y-fill.svg": [
		33811,
		33811
	],
	"./sign-intersection-y.svg": [
		15951,
		15951
	],
	"./sign-intersection.svg": [
		31685,
		31685
	],
	"./sign-merge-left-fill.svg": [
		83986,
		83986
	],
	"./sign-merge-left.svg": [
		13656,
		13656
	],
	"./sign-merge-right-fill.svg": [
		52699,
		52699
	],
	"./sign-merge-right.svg": [
		17895,
		17895
	],
	"./sign-no-left-turn-fill.svg": [
		66009,
		66009
	],
	"./sign-no-left-turn.svg": [
		89773,
		89773
	],
	"./sign-no-parking-fill.svg": [
		94358,
		94358
	],
	"./sign-no-parking.svg": [
		37940,
		37940
	],
	"./sign-no-right-turn-fill.svg": [
		73572,
		73572
	],
	"./sign-no-right-turn.svg": [
		39754,
		39754
	],
	"./sign-railroad-fill.svg": [
		59294,
		59294
	],
	"./sign-railroad.svg": [
		41292,
		41292
	],
	"./sign-stop-fill.svg": [
		42928,
		42928
	],
	"./sign-stop-lights-fill.svg": [
		15950,
		15950
	],
	"./sign-stop-lights.svg": [
		60956,
		60956
	],
	"./sign-stop.svg": [
		46193,
		68574
	],
	"./sign-turn-left-fill.svg": [
		24123,
		24123
	],
	"./sign-turn-left.svg": [
		3815,
		3815
	],
	"./sign-turn-right-fill.svg": [
		59980,
		59980
	],
	"./sign-turn-right.svg": [
		23618,
		23618
	],
	"./sign-turn-slight-left-fill.svg": [
		91645,
		91645
	],
	"./sign-turn-slight-left.svg": [
		60649,
		60649
	],
	"./sign-turn-slight-right-fill.svg": [
		54742,
		54742
	],
	"./sign-turn-slight-right.svg": [
		68436,
		68436
	],
	"./sign-yield-fill.svg": [
		77233,
		77233
	],
	"./sign-yield.svg": [
		35285,
		35285
	],
	"./signal.svg": [
		30346,
		30346
	],
	"./signpost-2-fill.svg": [
		65956,
		65956
	],
	"./signpost-2.svg": [
		35786,
		35786
	],
	"./signpost-fill.svg": [
		41811,
		41811
	],
	"./signpost-split-fill.svg": [
		9042,
		9042
	],
	"./signpost-split.svg": [
		44664,
		44664
	],
	"./signpost.svg": [
		11695,
		11695
	],
	"./sim-fill.svg": [
		45115,
		45115
	],
	"./sim-slash-fill.svg": [
		59775,
		59775
	],
	"./sim-slash.svg": [
		37971,
		37971
	],
	"./sim.svg": [
		63943,
		63943
	],
	"./sina-weibo.svg": [
		85502,
		85502
	],
	"./skip-backward-btn-fill.svg": [
		55838,
		55838
	],
	"./skip-backward-btn.svg": [
		98284,
		98284
	],
	"./skip-backward-circle-fill.svg": [
		88506,
		88506
	],
	"./skip-backward-circle.svg": [
		69648,
		69648
	],
	"./skip-backward-fill.svg": [
		53087,
		53087
	],
	"./skip-backward.svg": [
		98611,
		98611
	],
	"./skip-end-btn-fill.svg": [
		44858,
		44858
	],
	"./skip-end-btn.svg": [
		49136,
		49136
	],
	"./skip-end-circle-fill.svg": [
		33662,
		33662
	],
	"./skip-end-circle.svg": [
		46636,
		46636
	],
	"./skip-end-fill.svg": [
		79411,
		79411
	],
	"./skip-end.svg": [
		48719,
		48719
	],
	"./skip-forward-btn-fill.svg": [
		34277,
		56658
	],
	"./skip-forward-btn.svg": [
		73848,
		73848
	],
	"./skip-forward-circle-fill.svg": [
		58870,
		58870
	],
	"./skip-forward-circle.svg": [
		46388,
		46388
	],
	"./skip-forward-fill.svg": [
		48299,
		48299
	],
	"./skip-forward.svg": [
		75415,
		75415
	],
	"./skip-start-btn-fill.svg": [
		84599,
		84599
	],
	"./skip-start-btn.svg": [
		62395,
		62395
	],
	"./skip-start-circle-fill.svg": [
		62285,
		62285
	],
	"./skip-start-circle.svg": [
		43993,
		43993
	],
	"./skip-start-fill.svg": [
		42686,
		42686
	],
	"./skip-start.svg": [
		33548,
		33548
	],
	"./skype.svg": [
		46616,
		46616
	],
	"./slack.svg": [
		1930,
		1930
	],
	"./slash-circle-fill.svg": [
		13576,
		13576
	],
	"./slash-circle.svg": [
		38310,
		38310
	],
	"./slash-lg.svg": [
		55925,
		55925
	],
	"./slash-square-fill.svg": [
		20727,
		20727
	],
	"./slash-square.svg": [
		77147,
		77147
	],
	"./slash.svg": [
		91689,
		91689
	],
	"./sliders.svg": [
		72168,
		72168
	],
	"./sliders2-vertical.svg": [
		16237,
		16237
	],
	"./sliders2.svg": [
		83754,
		83754
	],
	"./smartwatch.svg": [
		11502,
		11502
	],
	"./snapchat.svg": [
		18636,
		18636
	],
	"./snow.svg": [
		17107,
		17107
	],
	"./snow2.svg": [
		56011,
		56011
	],
	"./snow3.svg": [
		78490,
		78490
	],
	"./sort-alpha-down-alt.svg": [
		69744,
		69744
	],
	"./sort-alpha-down.svg": [
		66226,
		66226
	],
	"./sort-alpha-up-alt.svg": [
		14243,
		14243
	],
	"./sort-alpha-up.svg": [
		96193,
		96193
	],
	"./sort-down-alt.svg": [
		94869,
		94869
	],
	"./sort-down.svg": [
		94491,
		94491
	],
	"./sort-numeric-down-alt.svg": [
		40935,
		40935
	],
	"./sort-numeric-down.svg": [
		42941,
		42941
	],
	"./sort-numeric-up-alt.svg": [
		6496,
		6496
	],
	"./sort-numeric-up.svg": [
		37698,
		37698
	],
	"./sort-up-alt.svg": [
		81202,
		81202
	],
	"./sort-up.svg": [
		75284,
		75284
	],
	"./soundwave.svg": [
		41252,
		41252
	],
	"./sourceforge.svg": [
		84326,
		84326
	],
	"./speaker-fill.svg": [
		85137,
		85137
	],
	"./speaker.svg": [
		821,
		821
	],
	"./speedometer.svg": [
		81985,
		81985
	],
	"./speedometer2.svg": [
		46625,
		46625
	],
	"./spellcheck.svg": [
		61832,
		61832
	],
	"./spotify.svg": [
		60344,
		60344
	],
	"./square-fill.svg": [
		14835,
		14835
	],
	"./square-half.svg": [
		77259,
		77259
	],
	"./square.svg": [
		58767,
		58767
	],
	"./stack-overflow.svg": [
		10509,
		10509
	],
	"./stack.svg": [
		44754,
		44754
	],
	"./star-fill.svg": [
		87228,
		87228
	],
	"./star-half.svg": [
		64304,
		64304
	],
	"./star.svg": [
		42066,
		42066
	],
	"./stars.svg": [
		4973,
		4973
	],
	"./steam.svg": [
		18826,
		18826
	],
	"./stickies-fill.svg": [
		77759,
		77759
	],
	"./stickies.svg": [
		74323,
		74323
	],
	"./sticky-fill.svg": [
		48131,
		48131
	],
	"./sticky.svg": [
		62399,
		62399
	],
	"./stop-btn-fill.svg": [
		31349,
		31349
	],
	"./stop-btn.svg": [
		18065,
		18065
	],
	"./stop-circle-fill.svg": [
		2123,
		2123
	],
	"./stop-circle.svg": [
		59415,
		59415
	],
	"./stop-fill.svg": [
		52324,
		52324
	],
	"./stop.svg": [
		61546,
		61546
	],
	"./stoplights-fill.svg": [
		41973,
		41973
	],
	"./stoplights.svg": [
		98865,
		98865
	],
	"./stopwatch-fill.svg": [
		57115,
		57115
	],
	"./stopwatch.svg": [
		34503,
		34503
	],
	"./strava.svg": [
		56843,
		56843
	],
	"./stripe.svg": [
		63837,
		63837
	],
	"./subscript.svg": [
		90157,
		90157
	],
	"./substack.svg": [
		6092,
		6092
	],
	"./subtract.svg": [
		81710,
		81710
	],
	"./suit-club-fill.svg": [
		70556,
		70556
	],
	"./suit-club.svg": [
		57330,
		57330
	],
	"./suit-diamond-fill.svg": [
		84171,
		84171
	],
	"./suit-diamond.svg": [
		49302,
		49302
	],
	"./suit-heart-fill.svg": [
		25764,
		25764
	],
	"./suit-heart.svg": [
		96298,
		96298
	],
	"./suit-spade-fill.svg": [
		41005,
		41005
	],
	"./suit-spade.svg": [
		74361,
		74361
	],
	"./suitcase-fill.svg": [
		79737,
		79737
	],
	"./suitcase-lg-fill.svg": [
		45917,
		45917
	],
	"./suitcase-lg.svg": [
		26441,
		26441
	],
	"./suitcase.svg": [
		7821,
		7821
	],
	"./suitcase2-fill.svg": [
		65025,
		65025
	],
	"./suitcase2.svg": [
		14021,
		14021
	],
	"./sun-fill.svg": [
		77546,
		77546
	],
	"./sun.svg": [
		87488,
		87488
	],
	"./sunglasses.svg": [
		95496,
		95496
	],
	"./sunrise-fill.svg": [
		97083,
		97083
	],
	"./sunrise.svg": [
		29959,
		29959
	],
	"./sunset-fill.svg": [
		27162,
		27162
	],
	"./sunset.svg": [
		6064,
		6064
	],
	"./superscript.svg": [
		87070,
		87070
	],
	"./symmetry-horizontal.svg": [
		99957,
		99957
	],
	"./symmetry-vertical.svg": [
		50691,
		50691
	],
	"./table.svg": [
		70038,
		70038
	],
	"./tablet-fill.svg": [
		14600,
		14600
	],
	"./tablet-landscape-fill.svg": [
		6208,
		6208
	],
	"./tablet-landscape.svg": [
		78222,
		78222
	],
	"./tablet.svg": [
		34854,
		34854
	],
	"./tag-fill.svg": [
		10332,
		10332
	],
	"./tag.svg": [
		87442,
		87442
	],
	"./tags-fill.svg": [
		97017,
		97017
	],
	"./tags.svg": [
		98957,
		98957
	],
	"./taxi-front-fill.svg": [
		70850,
		70850
	],
	"./taxi-front.svg": [
		67752,
		67752
	],
	"./telegram.svg": [
		70899,
		70899
	],
	"./telephone-fill.svg": [
		40308,
		40308
	],
	"./telephone-forward-fill.svg": [
		95772,
		95772
	],
	"./telephone-forward.svg": [
		36946,
		36946
	],
	"./telephone-inbound-fill.svg": [
		81064,
		81064
	],
	"./telephone-inbound.svg": [
		29222,
		29222
	],
	"./telephone-minus-fill.svg": [
		94533,
		94533
	],
	"./telephone-minus.svg": [
		13569,
		13569
	],
	"./telephone-outbound-fill.svg": [
		75583,
		75583
	],
	"./telephone-outbound.svg": [
		79091,
		79091
	],
	"./telephone-plus-fill.svg": [
		39343,
		39343
	],
	"./telephone-plus.svg": [
		8515,
		8515
	],
	"./telephone-x-fill.svg": [
		65413,
		65413
	],
	"./telephone-x.svg": [
		22465,
		22465
	],
	"./telephone.svg": [
		74074,
		74074
	],
	"./tencent-qq.svg": [
		28236,
		28236
	],
	"./terminal-dash.svg": [
		8355,
		8355
	],
	"./terminal-fill.svg": [
		81932,
		81932
	],
	"./terminal-plus.svg": [
		74971,
		74971
	],
	"./terminal-split.svg": [
		89413,
		89413
	],
	"./terminal-x.svg": [
		20329,
		20329
	],
	"./terminal.svg": [
		59298,
		59298
	],
	"./text-center.svg": [
		42475,
		42475
	],
	"./text-indent-left.svg": [
		42983,
		65364
	],
	"./text-indent-right.svg": [
		47963,
		47963
	],
	"./text-left.svg": [
		8723,
		8723
	],
	"./text-paragraph.svg": [
		28466,
		28466
	],
	"./text-right.svg": [
		22870,
		22870
	],
	"./text-wrap.svg": [
		61596,
		61596
	],
	"./textarea-resize.svg": [
		56305,
		56305
	],
	"./textarea-t.svg": [
		3927,
		3927
	],
	"./textarea.svg": [
		55092,
		55092
	],
	"./thermometer-half.svg": [
		50932,
		50932
	],
	"./thermometer-high.svg": [
		44020,
		44020
	],
	"./thermometer-low.svg": [
		1547,
		1547
	],
	"./thermometer-snow.svg": [
		42142,
		42142
	],
	"./thermometer-sun.svg": [
		75851,
		75851
	],
	"./thermometer.svg": [
		1654,
		1654
	],
	"./threads-fill.svg": [
		90501,
		90501
	],
	"./threads.svg": [
		92769,
		92769
	],
	"./three-dots-vertical.svg": [
		80886,
		80886
	],
	"./three-dots.svg": [
		45591,
		45591
	],
	"./thunderbolt-fill.svg": [
		67409,
		67409
	],
	"./thunderbolt.svg": [
		45621,
		45621
	],
	"./ticket-detailed-fill.svg": [
		61419,
		61419
	],
	"./ticket-detailed.svg": [
		82103,
		82103
	],
	"./ticket-fill.svg": [
		26224,
		26224
	],
	"./ticket-perforated-fill.svg": [
		20609,
		20609
	],
	"./ticket-perforated.svg": [
		54866,
		54866
	],
	"./ticket.svg": [
		53342,
		53342
	],
	"./tiktok.svg": [
		3236,
		3236
	],
	"./toggle-off.svg": [
		6906,
		6906
	],
	"./toggle-on.svg": [
		30244,
		30244
	],
	"./toggle2-off.svg": [
		92440,
		92440
	],
	"./toggle2-on.svg": [
		40242,
		40242
	],
	"./toggles.svg": [
		22645,
		22645
	],
	"./toggles2.svg": [
		4413,
		4413
	],
	"./tools.svg": [
		40627,
		40627
	],
	"./tornado.svg": [
		51549,
		51549
	],
	"./train-freight-front-fill.svg": [
		8778,
		8778
	],
	"./train-freight-front.svg": [
		94272,
		94272
	],
	"./train-front-fill.svg": [
		79904,
		79904
	],
	"./train-front.svg": [
		76014,
		76014
	],
	"./train-lightrail-front-fill.svg": [
		99621,
		99621
	],
	"./train-lightrail-front.svg": [
		76865,
		76865
	],
	"./translate.svg": [
		90372,
		90372
	],
	"./transparency.svg": [
		55244,
		55244
	],
	"./trash-fill.svg": [
		82270,
		82270
	],
	"./trash.svg": [
		47103,
		69484
	],
	"./trash2-fill.svg": [
		69880,
		69880
	],
	"./trash2.svg": [
		26038,
		3657
	],
	"./trash3-fill.svg": [
		71163,
		71163
	],
	"./trash3.svg": [
		13159,
		13159
	],
	"./tree-fill.svg": [
		71688,
		71688
	],
	"./tree.svg": [
		57158,
		57158
	],
	"./trello.svg": [
		40332,
		40332
	],
	"./triangle-fill.svg": [
		44220,
		44220
	],
	"./triangle-half.svg": [
		13072,
		13072
	],
	"./triangle.svg": [
		19474,
		19474
	],
	"./trophy-fill.svg": [
		90058,
		90058
	],
	"./trophy.svg": [
		13088,
		13088
	],
	"./tropical-storm.svg": [
		5562,
		5562
	],
	"./truck-flatbed.svg": [
		84238,
		84238
	],
	"./truck-front-fill.svg": [
		99517,
		99517
	],
	"./truck-front.svg": [
		29673,
		29673
	],
	"./truck.svg": [
		74099,
		74099
	],
	"./tsunami.svg": [
		20499,
		20499
	],
	"./tux.svg": [
		68561,
		68561
	],
	"./tv-fill.svg": [
		36394,
		36394
	],
	"./tv.svg": [
		33088,
		33088
	],
	"./twitch.svg": [
		37991,
		37991
	],
	"./twitter-x.svg": [
		49932,
		49932
	],
	"./twitter.svg": [
		18227,
		18227
	],
	"./type-bold.svg": [
		33798,
		33798
	],
	"./type-h1.svg": [
		45354,
		45354
	],
	"./type-h2.svg": [
		6105,
		6105
	],
	"./type-h3.svg": [
		98184,
		98184
	],
	"./type-h4.svg": [
		17991,
		17991
	],
	"./type-h5.svg": [
		30870,
		30870
	],
	"./type-h6.svg": [
		72117,
		72117
	],
	"./type-italic.svg": [
		95347,
		95347
	],
	"./type-strikethrough.svg": [
		61080,
		61080
	],
	"./type-underline.svg": [
		20249,
		20249
	],
	"./type.svg": [
		50642,
		50642
	],
	"./typescript.svg": [
		6255,
		6255
	],
	"./ubuntu.svg": [
		34323,
		34323
	],
	"./ui-checks-grid.svg": [
		73775,
		73775
	],
	"./ui-checks.svg": [
		92973,
		92973
	],
	"./ui-radios-grid.svg": [
		28286,
		28286
	],
	"./ui-radios.svg": [
		817,
		817
	],
	"./umbrella-fill.svg": [
		96208,
		96208
	],
	"./umbrella.svg": [
		77822,
		77822
	],
	"./unindent.svg": [
		39353,
		39353
	],
	"./union.svg": [
		80615,
		80615
	],
	"./unity.svg": [
		63017,
		63017
	],
	"./universal-access-circle.svg": [
		66558,
		66558
	],
	"./universal-access.svg": [
		58916,
		58916
	],
	"./unlock-fill.svg": [
		21008,
		21008
	],
	"./unlock.svg": [
		37790,
		37790
	],
	"./unlock2-fill.svg": [
		38170,
		38170
	],
	"./unlock2.svg": [
		20912,
		20912
	],
	"./upc-scan.svg": [
		28034,
		28034
	],
	"./upc.svg": [
		4584,
		4584
	],
	"./upload.svg": [
		65209,
		65209
	],
	"./usb-c-fill.svg": [
		67570,
		67570
	],
	"./usb-c.svg": [
		68984,
		68984
	],
	"./usb-drive-fill.svg": [
		88375,
		88375
	],
	"./usb-drive.svg": [
		61819,
		61819
	],
	"./usb-fill.svg": [
		19782,
		19782
	],
	"./usb-micro-fill.svg": [
		12047,
		12047
	],
	"./usb-micro.svg": [
		13443,
		13443
	],
	"./usb-mini-fill.svg": [
		88558,
		88558
	],
	"./usb-mini.svg": [
		77116,
		77116
	],
	"./usb-plug-fill.svg": [
		12629,
		12629
	],
	"./usb-plug.svg": [
		76753,
		76753
	],
	"./usb-symbol.svg": [
		23673,
		23673
	],
	"./usb.svg": [
		57828,
		57828
	],
	"./valentine.svg": [
		36680,
		36680
	],
	"./valentine2.svg": [
		41194,
		41194
	],
	"./vector-pen.svg": [
		92273,
		92273
	],
	"./view-list.svg": [
		3657,
		26038
	],
	"./view-stacked.svg": [
		6349,
		6349
	],
	"./vignette.svg": [
		32220,
		32220
	],
	"./vimeo.svg": [
		47162,
		47162
	],
	"./vinyl-fill.svg": [
		52392,
		52392
	],
	"./vinyl.svg": [
		57350,
		57350
	],
	"./virus.svg": [
		32329,
		32329
	],
	"./virus2.svg": [
		25529,
		25529
	],
	"./voicemail.svg": [
		37229,
		37229
	],
	"./volume-down-fill.svg": [
		31021,
		31021
	],
	"./volume-down.svg": [
		36953,
		36953
	],
	"./volume-mute-fill.svg": [
		29644,
		29644
	],
	"./volume-mute.svg": [
		32258,
		9877
	],
	"./volume-off-fill.svg": [
		43758,
		43758
	],
	"./volume-off.svg": [
		33948,
		33948
	],
	"./volume-up-fill.svg": [
		63211,
		85592
	],
	"./volume-up.svg": [
		64201,
		86582
	],
	"./vr.svg": [
		48258,
		48258
	],
	"./wallet-fill.svg": [
		71313,
		71313
	],
	"./wallet.svg": [
		48565,
		48565
	],
	"./wallet2.svg": [
		42685,
		42685
	],
	"./watch.svg": [
		95391,
		95391
	],
	"./water.svg": [
		36219,
		36219
	],
	"./webcam-fill.svg": [
		56841,
		56841
	],
	"./webcam.svg": [
		66557,
		66557
	],
	"./wechat.svg": [
		52268,
		52268
	],
	"./whatsapp.svg": [
		39300,
		33271
	],
	"./wifi-1.svg": [
		37835,
		37835
	],
	"./wifi-2.svg": [
		79768,
		79768
	],
	"./wifi-off.svg": [
		74085,
		74085
	],
	"./wifi.svg": [
		63985,
		63985
	],
	"./wikipedia.svg": [
		50891,
		50891
	],
	"./wind.svg": [
		6812,
		6812
	],
	"./window-dash.svg": [
		99775,
		99775
	],
	"./window-desktop.svg": [
		83617,
		83617
	],
	"./window-dock.svg": [
		96825,
		96825
	],
	"./window-fullscreen.svg": [
		81672,
		81672
	],
	"./window-plus.svg": [
		64991,
		64991
	],
	"./window-sidebar.svg": [
		97157,
		97157
	],
	"./window-split.svg": [
		77073,
		77073
	],
	"./window-stack.svg": [
		95005,
		95005
	],
	"./window-x.svg": [
		74501,
		74501
	],
	"./window.svg": [
		21270,
		21270
	],
	"./windows.svg": [
		69161,
		69161
	],
	"./wordpress.svg": [
		46475,
		46475
	],
	"./wrench-adjustable-circle-fill.svg": [
		32126,
		32126
	],
	"./wrench-adjustable-circle.svg": [
		33164,
		33164
	],
	"./wrench-adjustable.svg": [
		67951,
		67951
	],
	"./wrench.svg": [
		81589,
		81589
	],
	"./x-circle-fill.svg": [
		53503,
		53503
	],
	"./x-circle.svg": [
		67283,
		67283
	],
	"./x-diamond-fill.svg": [
		6209,
		6209
	],
	"./x-diamond.svg": [
		61413,
		61413
	],
	"./x-lg.svg": [
		90004,
		90004
	],
	"./x-octagon-fill.svg": [
		9877,
		32258
	],
	"./x-octagon.svg": [
		55944,
		55944
	],
	"./x-square-fill.svg": [
		99196,
		99196
	],
	"./x-square.svg": [
		37810,
		37810
	],
	"./x.svg": [
		50441,
		50441
	],
	"./xbox.svg": [
		10965,
		10965
	],
	"./yelp.svg": [
		46052,
		46052
	],
	"./yin-yang.svg": [
		54744,
		54744
	],
	"./youtube.svg": [
		19161,
		19161
	],
	"./zoom-in.svg": [
		50949,
		50949
	],
	"./zoom-out.svg": [
		90172,
		90172
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59145;
module.exports = webpackAsyncContext;